<template>
  <div v-loading="showFlag">
    <t-card>
      <!-- 注文情報 -->
      <div :style="{ height: basicHeight + 'px' }">
        <t-form
          label-position="right"
          :label-width="$t('widgetSize.ORDER.SEARCH_LABEL_WIDTH')"
        >
          <t-collapse v-model="activeNames" @change="handleCollapseChange">
            <t-collapse-item title="手配基本情報" name="orderBasic">
              <t-row
                type="flex"
                justify="center
          "
              >
                <t-col :span="colArr.colL">&nbsp;</t-col>

                <!-- 注文No -->
                <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.COMMON_CONSTANT.ORDER_NO')"
                    class="marginBottom"
                  >
                    <t-input
                      v-model="orderEditForm.obOrderNoShow"
                      class="commonDialog"
                      disabled
                    >
                    </t-input>
                  </t-form-item>
                </t-col>

                <!-- 仕入先 -->
                <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.COMMON_CONSTANT.SUPPLIER')"
                    class="marginBottom"
                  >
                    <!--UPD 2024/12/16 ZLL 課题_受注製品変更の検討 start↓ -->
                    <!-- <t-select
                      placeholder=""
                      class="commonDialog"
                      v-model="orderEditForm.obSupCode"
                    > -->
                    <!-- UPD 2025/03/19 ZLL 課題_手配の仕入先が選択不可を変更 start↓ -->
                    <!-- <t-select
                      placeholder=""
                      class="commonDialog"
                      v-model="orderEditForm.obSupCode"
                      :disabled="!localIsAdd"
                    > -->
                    <t-select
                      placeholder=""
                      class="commonDialog"
                      v-model="orderEditForm.obSupCode"
                      disabled
                    >
                      <!-- UPD 2025/03/19 ZLL 課題_手配の仕入先が選択不可を変更 end↑ -->
                      <!--UPD 2024/12/16 ZLL 課题_受注製品変更の検討 end↑ -->
                      <!-- :disabled="btnOrdSelectFlag"
                         @clear="clearClick('clear')"
                      @change="clearClick('change')" -->
                      <t-option
                        v-for="item in supplierCpyList"
                        :key="item.supCode"
                        :label="item.supCode + ':' + item.supAbbreviation"
                        :value="item.supCode"
                      >
                      </t-option>
                    </t-select>
                  </t-form-item>
                </t-col>

                <!-- 注文日 -->
                <!--UPD 2024/12/16 ZLL 課题_受注製品変更の検討 start↓ -->
                <!-- <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.ORDER.ORDER_DATE')"
                    class="marginBottom"
                  >
                    <t-date-picker
                      v-model="orderEditForm.obDate"
                      class="dialogDate"
                      :clearable="false"
                      type="date"
                      :editable="false"
                      value-format="yyyy/MM/dd"
                      format="yyyy/MM/dd"
                    >
                    </t-date-picker>
                  </t-form-item>
                </t-col> -->

                <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.ORDER.ORDER_DATE')"
                    class="marginBottom"
                  >
                    <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓ -->
                    <!-- 品質保証部の権限を追加する -->
                    <!-- <t-date-picker
                      v-model="orderEditForm.obDate"
                      class="dialogDate"
                      :clearable="false"
                      type="date"
                      :editable="false"
                      value-format="yyyy/MM/dd"
                      format="yyyy/MM/dd"
                      :disabled="!orderDateFlg"
                    > -->
                    <t-date-picker
                      v-model="orderEditForm.obDate"
                      class="dialogDate"
                      :clearable="false"
                      type="date"
                      :editable="false"
                      value-format="yyyy/MM/dd"
                      format="yyyy/MM/dd"
                      :disabled="!localIsAdd || isDLUserLocal"
                    >
                      <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑ -->
                    </t-date-picker>
                  </t-form-item>
                </t-col>
                <!--UPD 2024/12/16 ZLL 課题_受注製品変更の検討 end↑ -->

                <t-col :span="colArr.colCom">
                  <!-- UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
                  <!-- 納期、注番の変更(見積単位⇒製品単位に変更) -->
                  <!-- <t-form-item
                    :label="$t('resource.ORDER.DELIVERY_DATE')"
                    class="marginBottom"
                  >
                    <t-date-picker
                      v-model="orderEditForm.obDueDate"
                      class="dialogDate"
                      :clearable="false"
                      type="date"
                      :editable="false"
                      value-format="yyyy/MM/dd"
                      format="yyyy/MM/dd"
                    >
                    </t-date-picker>
                  </t-form-item> -->
                  <t-form-item
                    :label="$t('resource.ORDER.PROC_KBN')"
                    class="marginBottom"
                  >
                    <t-select
                      clearable
                      placeholder=""
                      class="commonDialog"
                      v-model="orderEditForm.obProcKbn"
                      disabled
                    >
                      <t-option
                        v-for="item in procKbnList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </t-option>
                    </t-select>
                  </t-form-item>

                  <!-- UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑ -->
                </t-col>
                <t-col :span="colArr.colR">&nbsp;</t-col>
              </t-row>
              <t-row type="flex" justify="center">
                <t-col :span="colArr.colL">&nbsp;</t-col>

                <!-- 状態 -->
                <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.ORDER.STATUS')"
                    class="marginBottom"
                  >
                    <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓ -->
                    <!-- 品質保証部の権限を追加する -->
                    <!-- <t-select
                      v-model="orderEditForm.obStatus"
                      placeholder=""
                      class="commonDialog"
                    > -->
                    <t-select
                      v-model="orderEditForm.obStatus"
                      placeholder=""
                      class="commonDialog"
                      :disabled="isDLUserLocal"
                    >
                      <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑ -->
                      <t-option
                        v-for="item in orderStatusList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </t-option>
                    </t-select>
                  </t-form-item>
                </t-col>

                <!-- 支払状態 -->
                <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.ORDER.PAYMENT_STATUS')"
                    class="marginBottom"
                  >
                    <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓ -->
                    <!-- 品質保証部の権限を追加する -->
                    <!-- <t-select
                      v-model="orderEditForm.obPayStatus"
                      placeholder=""
                      class="commonDialog"
                    > -->
                    <t-select
                      v-model="orderEditForm.obPayStatus"
                      placeholder=""
                      class="commonDialog"
                      :disabled="isDLUserLocal"
                    >
                      <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑ -->
                      <t-option
                        v-for="item in paymentStatusList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </t-option>
                    </t-select>
                  </t-form-item>
                </t-col>

                <!-- 担当者 -->
                <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.COMMON_CONSTANT.CONNECTER')"
                    class="marginBottom"
                  >
                    <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓ -->
                    <!-- 品質保証部の権限を追加する -->
                    <!-- <t-select
                      v-model="orderEditForm.obUserCode"
                      placeholder=""
                      class="commonDialog"
                    > -->
                    <t-select
                      v-model="orderEditForm.obUserCode"
                      placeholder=""
                      class="commonDialog"
                      :disabled="isDLUserLocal"
                    >
                      <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑ -->
                      <t-option
                        v-for="item in connecterList"
                        :key="item.UserId"
                        :label="item.UserName"
                        :value="item.UserId"
                      >
                      </t-option>
                    </t-select>
                  </t-form-item>
                </t-col>

                <!-- 輸送方式 -->
                <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.ORDER.TRANS_METHOD')"
                    class="marginBottom"
                  >
                    <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓ -->
                    <!-- 品質保証部の権限を追加する -->
                    <!-- <t-select
                      :clearable="false"
                      placeholder=""
                      class="commonDialog"
                      v-model="orderEditForm.obTransMethod"
                      :disabled="obTransMethodFlg"
                    > -->
                    <t-select
                      :clearable="false"
                      placeholder=""
                      class="commonDialog"
                      v-model="orderEditForm.obTransMethod"
                      :disabled="obTransMethodFlg || isDLUserLocal"
                    >
                      <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑ -->
                      <t-option
                        v-for="item in transMethodList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </t-option>
                    </t-select>
                  </t-form-item>
                </t-col>
                <t-col :span="colArr.colR" />
              </t-row>
              <!-- UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
              <!-- 課題_備考機能の追加 -->
              <!-- <t-row type="flex" justify="center" style="height: 45px"> -->
              <!-- UPD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓ -->
              <!-- 目的港の追加 -->
              <!-- <t-row
                type="flex"
                justify="center"
                style="height: 45px"
                v-if="quoteType === '3'"
              > -->
              <t-row type="flex" justify="center" style="height: 45px">
                <!-- UPD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑ -->
                <!-- UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑ -->
                <t-col :span="colArr.colL">&nbsp;</t-col>

                <!-- プロセス区分 -->
                <!-- DEL 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
                <!-- 納期、注番の変更(見積単位⇒製品単位に変更) -->
                <!-- 位置移動 -->
                <!-- <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.ORDER.PROC_KBN')"
                    class="marginBottom"
                  >
                    <t-select
                      clearable
                      placeholder=""
                      class="commonDialog"
                      v-model="orderEditForm.obProcKbn"
                      disabled
                    >
                      <t-option
                        v-for="item in procKbnList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </t-option>
                    </t-select>
                  </t-form-item>
                </t-col> -->
                <!-- DEL 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑ -->

                <!-- ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓ -->
                <!-- 目的港の追加 -->
                <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.ORDER.DESTINATION_PORT')"
                    class="marginBottom"
                  >
                    <t-select
                      :clearable="false"
                      placeholder=""
                      class="commonDialog"
                      v-model="orderEditForm.obDestinationCode"
                      :disabled="obDestPortFlg || isDLUserLocal"
                    >
                      <t-option
                        v-for="item in destinationList"
                        :key="item.dpCode"
                        :label="item.dpName"
                        :value="item.dpCode"
                      >
                      </t-option>
                    </t-select>
                  </t-form-item>
                </t-col>
                <!-- ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑ -->

                <t-col :span="colArr.colCom">
                  <!-- ADD 2024/12/16 ZLL 課题_受注製品変更の検討 start↓ -->
                  <t-form-item
                    :label="$t('resource.ACCEPT_ORDER.QUOTE_TYPE')"
                    class="marginBottom"
                    v-show="quoteType === '3'"
                  >
                    <t-input
                      v-model="quoteTypeVal"
                      class="commonDialog"
                      maxlength="20"
                      disabled
                    >
                    </t-input>
                  </t-form-item>
                  <!-- ADD 2024/12/16 ZLL 課题_受注製品変更の検討 end↑ -->
                </t-col>
                <!-- ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
                <!-- 納期、注番の変更(見積単位⇒製品単位に変更) -->
                <!-- DEL 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓ -->
                <!-- 目的港の追加 -->
                <!-- <t-col :span="colArr.colCom"> &nbsp;</t-col> -->
                <!-- DEL 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑ -->

                <!-- ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑ -->

                <t-col :span="colArr.colCom"> </t-col>

                <t-col :span="colArr.colCom"> </t-col>
                <t-col :span="colArr.colR"> </t-col>
              </t-row>
            </t-collapse-item>
          </t-collapse>

          <t-row>
            <t-col
              :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_FOUR'))"
              class="col_common_left"
            >
              <!-- 受注一覧選択 -->

              <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓ -->
              <!-- 品質保証部の権限を追加する -->
              <!-- <t-button
                round
                type="primary"
                class="dialogButton_150_40"
                ref="ordSelectBtn"
                @click="showOrderProdDialog"
                :disabled="btnOrdSelectFlag"
              > -->
              <t-button
                round
                type="primary"
                class="dialogButton_150_40"
                ref="ordSelectBtn"
                @click="showOrderProdDialog"
                :disabled="btnOrdSelectFlag || isDLUserLocal"
              >
                <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑ -->
                <i class="el-icon-zoom-in" />
                {{ $t("resource.ORDER.ORDER_LIST_SELECT") }}
              </t-button></t-col
            >

            <t-col
              :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_FOUR'))"
              class="col_common_left"
            >
              <!-- 社内加工原価 -->
              <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓ -->
              <!-- 品質保証部の権限を追加する -->
              <!-- <t-button
                round
                type="primary"
                class="dialogButton_150_40"
                ref="internalProcessBtn"
                @click="showInternalProcessDialog"
                :disabled="btnInternalSelectFlag"
              > -->
              <t-button
                round
                type="primary"
                class="dialogButton_150_40"
                ref="internalProcessBtn"
                @click="showInternalProcessDialog"
                :disabled="btnInternalSelectFlag || isDLUserLocal"
              >
                <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑ -->
                <i class="el-icon-edit"></i>
                {{ $t("resource.ORDER.INTERNAL_PROCESS_COST") }}
              </t-button></t-col
            >

            <!-- <t-col
              :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_TWELVE'))"
              >&nbsp;</t-col
            > -->

            <!-- UPD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 start↓ -->
            <!-- <t-col
              :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_SIXTEEN'))"
              class="right"
            > -->
            <!-- 一括至急の追加 -->
            <t-col :span="3" class="col_common_left">
              <template>
                <!-- 一括至急のチェックボックス -->
                <t-checkbox
                  v-model="allUrgentFlg"
                  @change="allUrgentCheckboxChange"
                  :label="$t('resource.ACCEPT_ORDER.SET_ALL_URGENT')"
                  style="line-height: 3; margin-top: 3px; margin-left: 5px"
                  :disabled="isDLUserLocal"
                />
              </template>
            </t-col>
            <!-- UPD 2026/10/10 Wjx フロント画面コントロールのロードの最適化 start↓ -->
            <!-- <t-col :span="13" class="right">-->

            <t-col :span="3" class="col_common_left">
              <template>
                <!-- 編集列の選択ボックス -->
                <t-select
                  placeholder="編集列を選択する"
                  v-model="editingColumn"
                  class="input_icon_close"
                  style="margin-top: 10px"
                  :disabled="isDLUserLocal"
                  clearable
                >
                  <t-option
                    v-for="item in editingList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </t-option>
                </t-select>
              </template>
            </t-col>
            <t-col :span="10" class="right">
              <!-- UPD 2026/10/10 Wjx フロント画面コントロールのロードの最適化 end↑ -->
              <!-- UPD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 end↑ -->

              <!-- 注文書出力 -->

              <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓ -->
              <!-- 品質保証部の権限を追加する -->
              <!-- <t-button
                round
                type="primary"
                class="dialogButton_150_40"
                ref="outPutBtn"
                :disabled="buttonClickFlag"
                @click="outPutClick"
              > -->
              <t-button
                round
                type="primary"
                class="dialogButton_150_40"
                ref="outPutBtn"
                :disabled="buttonClickFlag || isDLUserLocal"
                @click="outPutClick"
              >
                <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑ -->
                <i class="el-icon-download"></i>
                {{ $t("resource.ORDER.ORDER_EXCEL_OUTPUT") }}
              </t-button>
            </t-col>
          </t-row>
        </t-form>
      </div>

      <!-- 注文製品一覧 -->
      <div>
        <t-row class="marginBottom">
          <t-col
            :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_TWENTY_FOUR'))"
          >
            <!-- テーブル -->
            <div>
              <!--UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓ -->
              <!-- <t-table
                ref="productInfoTable"
                :data="productInfoTable"
                class="table_common"
                header-cell-class-name="bg-default"
                highlight-current-row
                :height="detailHeight"
                :cell-class-name="tableCellClassName"
                :row-class-name="rowClassName"
                background-color="yellow"
                border
                fit
              > -->
              <t-table
                ref="productInfoTable"
                :data="productInfoTable"
                class="table_common"
                header-cell-class-name="bg-default"
                highlight-current-row
                :height="detailHeight"
                :cell-class-name="tableCellClassName"
                :row-class-name="rowClassName"
                background-color="yellow"
                border
                fit
                row-key="id"
                default-expand-all
                :key="tableKey"
              >
                <!--UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑ -->

                <!-- :summary-method="calculateTotalData"
                show-summary -->
                <!-- テーブルの列 -->
                <!-- UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
                <!-- 画面と文字サイズの調整 -->
                <!-- <t-table-column
                  v-for="(column, index) in columns"
                  :key="index"
                  :type="column.type"
                  :prop="column.prop"
                  :label="column.label"
                  :min-width="column.width"
                  :align="column.align"
                  :header-align="column.headerAlign"
                  :class-name="column.class"
                  :show-overflow-tooltip="column.overflowTooltip"
                > -->
                <t-table-column
                  v-for="(column, index) in columns"
                  :key="index"
                  :type="column.type"
                  :prop="column.prop"
                  :label="column.label"
                  :min-width="column.width"
                  :fixed="index < 4"
                  :align="column.align"
                  :header-align="column.headerAlign"
                  :class-name="`${column.class} input_font_small`"
                  :show-overflow-tooltip="column.overflowTooltip"
                >
                  <!-- UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑ -->
                  <template slot-scope="scope">
                    <!-- <t-input-number
                      v-if="showInputNumberCell(scope.row, column)"
                      :class="[
                        'cell_input_number',
                        changeCellInputClass(scope.row),
                      ]"
                      :controls="false"
                      :precision="0"
                      :min="0"
                      :max="999999"
                      v-model="scope.row[column.prop]"
                      @change="changeCellData()"
                    ></t-input-number>
@change="changeCellData(scope.row)"
                     -->

                    <!--UPD 2024/12/16 ZLL 課题_受注製品変更の検討 start↓ -->
                    <!-- <t-input
                      v-if="showInputNumberCell(scope.row, column)"
                      :class="[
                        'cell_input_custom',
                        changeCellInputClass(scope.row),
                      ]"
                      :controls="false"
                      :maxlength="6"
                      v-model="scope.row[column.prop]"
                      @focus="changeCellDataToNumber(scope.row, column.prop)"
                      @blur="changeCellData(scope.row)"
                      @input="
                        scope.row[column.prop] = scope.row[column.prop].replace(
                          /[^\d]/g,
                          ''
                        )
                      "
                      :ref="`input${scope.row.index}-${column.prop}`"
                      @keyup.native.enter="
                        focusNextInput(scope.row.index, column.prop)
                      "
                    ></t-input> -->
                    <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓ -->
                    <!-- 品質保証部の権限を追加する -->
                    <!-- <t-input
                      v-if="
                        showInputNumberCell(scope.row, column) === 'odUPrice'
                      "
                      :class="[
                        'cell_input_custom cell_input_font_small',
                        changeCellInputClass(scope.row),
                      ]"
                      :controls="false"
                      :maxlength="8"
                      v-model="scope.row[column.prop]"
                      @focus="selectValue($event)"
                      @blur="changeCellData(scope.row)"
                      @input="
                        scope.row[column.prop] = scope.row[column.prop].replace(
                          /[^\d]/g,
                          ''
                        )
                      "
                      :ref="`input${scope.row.index}-${column.prop}`"
                      @keyup.native.enter="
                        remarksFocusNextInput(scope.row.index, column.prop)
                      "
                    ></t-input> -->

                    <t-input
                      v-if="
                        showInputNumberCell(scope.row, column) === 'odUPrice' &&
                        !isDLUserLocal
                      "
                      :class="[
                        'cell_input_custom cell_input_font_small',
                        changeCellInputClass(scope.row),
                      ]"
                      :controls="false"
                      :maxlength="8"
                      v-model="scope.row[column.prop]"
                      @focus="selectValue($event)"
                      @blur="changeCellData(scope.row)"
                      @input="
                        scope.row[column.prop] = scope.row[column.prop].replace(
                          /[^\d]/g,
                          ''
                        )
                      "
                      :ref="`input${scope.row.index}-${column.prop}`"
                      @keyup.native.enter="
                        remarksFocusNextInput(scope.row.index, column.prop)
                      "
                    ></t-input>
                    <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑ -->

                    <!-- //ADD 2025/01/02 Wzc 課題_仕様変更の対応 Start↓ -->
                    <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓ -->
                    <!-- 品質保証部の権限を追加する -->
                    <!-- <t-input
                      v-else-if="
                        showInputNumberCell(scope.row, column) === 'odUPriceCNY'
                      "
                      :class="[
                        'cell_input_custom cell_input_font_small',
                        changeCellInputClass(scope.row),
                      ]"
                      :controls="false"
                      :maxlength="7"
                      v-model="scope.row[column.prop]"
                      @focus="selectValue($event)"
                      @blur="changeCellData(scope.row)"
                      oninput="value=value.replace(/[^\d.]/g,'').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.') "
                      :ref="`input${scope.row.index}-${column.prop}`"
                      @keyup.native.enter="
                        remarksFocusNextInput(scope.row.index, column.prop)
                      "
                    ></t-input> -->
                    <t-input
                      v-else-if="
                        showInputNumberCell(scope.row, column) ===
                          'odUPriceCNY' && !isDLUserLocal
                      "
                      :class="[
                        'cell_input_custom cell_input_font_small',
                        changeCellInputClass(scope.row),
                      ]"
                      :controls="false"
                      :maxlength="7"
                      v-model="scope.row[column.prop]"
                      @focus="selectValue($event)"
                      @blur="changeCellData(scope.row)"
                      oninput="value=value.replace(/[^\d.]/g,'').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.') "
                      :ref="`input${scope.row.index}-${column.prop}`"
                      @keyup.native.enter="
                        remarksFocusNextInput(scope.row.index, column.prop)
                      "
                    ></t-input>
                    <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑ -->

                    <!-- //ADD 2025/01/02 Wzc 課題_仕様変更の対応 End↑ -->

                    <!-- DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
                    <!-- 課題_備考機能の追加 -->
                    <!-- <t-input
                      v-else-if="
                        showInputNumberCell(scope.row, column) ===
                        'odProdRemarks'
                      "
                      maxLength="200"
                      class="cell_input_font_small"
                      v-model="scope.row[column.prop]"
                      :ref="`input${scope.row.index}-${column.prop}`"
                      @keyup.native.enter="
                        remarksFocusNextInput(scope.row.index, column.prop)
                      "
                      @focus="selectValue($event)"
                    /> -->
                    <!-- DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑ -->

                    <!--UPD 2024/12/16 ZLL 課题_受注製品変更の検討 end↑ -->

                    <!-- ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
                    <!-- 納期、注番の変更(見積単位⇒製品単位に変更) -->

                    <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓ -->
                    <!-- 品質保証部の権限を追加する -->

                    <!-- <t-date-picker
                      v-else-if="dueDateInputProc(scope.row, column)"
                      v-model="scope.row[column.prop]"
                      class="dialogDate cell_input_font_small"
                      :clearable="false"
                      type="date"
                      value-format="yyyy/MM/dd"
                      format="yyyy/MM/dd"
                      :editable="false"
                      :show-icon="false"
                    >
                    </t-date-picker> -->
                    <t-date-picker
                      v-else-if="
                        dueDateInputProc(scope.row, column) && !isDLUserLocal
                      "
                      v-model="scope.row[column.prop]"
                      class="dialogDate cell_input_font_small"
                      :clearable="false"
                      type="date"
                      value-format="yyyy/MM/dd"
                      format="yyyy/MM/dd"
                      :editable="false"
                      :disabled="
                        (scope.row.odReduceKbn !== '-' ||
                          scope.row.odCloseStateBool) &&
                        !localIsAdd
                      "
                      :show-icon="false"
                    >
                    </t-date-picker>
                    <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑ -->

                    <!-- ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓ -->
                    <!-- 課題_納期分割機能の追加 -->
                    <t-checkbox
                      v-model="scope.row['odCloseStateBool']"
                      v-else-if="
                        column.prop === 'odCloseStateBool' &&
                        scope.row.id < 10000
                      "
                      :disabled="checkBoxDisableProc(scope.row)"
                    />
                    <!-- ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑ -->
                    <!-- ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑ -->

                    <!-- ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓ -->
                    <t-checkbox
                      v-model="scope.row['aodUrgentBool']"
                      v-else-if="
                        column.prop == 'aodUrgentBool' && scope.row.id < 10000
                      "
                      :disabled="
                        scope.row.odReduceKbn !== '-' ||
                        scope.row.odCloseStateBool ||
                        isDLUserLocal
                      "
                    />
                    <!-- ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑ -->
                    <span v-else>
                      {{ scope.row[column.prop] }}
                    </span>
                  </template>
                </t-table-column>

                <!-- ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
                <!-- 課題_備考機能の追加 -->
                <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓ -->
                <!-- 共通備考の調整 -->
                <!-- <t-table-column
                  :label="$t('resource.REMARKS_ADD.REMARKS')"
                  prop="aodProdRemarksSum"
                  :class-name="'cell_txt_center input_font_small'"
                  :min-width="100"
                >
                  <template slot-scope="scope">
                    <div v-if="scope.row.id < 10000" class="button-container">
                       <t-tooltip placement="bottom" effect="light">
                        <div
                          slot="content"
                          class="tooltip-content"
                          v-html="
                            formatRemarksShowProc(scope.row.aodProdRemarksSum)
                          "
                        ></div>
                        <t-button
                          :type="getIconTypeProc(scope.row.aodProdRemarksSum)"
                          icon="el-icon-search"
                          size="small"
                          circle
                        >
                        </t-button>
                      </t-tooltip>
                      <t-button
                        type="warning"
                        icon="el-icon-edit"
                        size="small"
                        circle
                        @click="addRemarksProd(scope.row, $event)"
                      ></t-button>
                    </div>
                  </template>
                </t-table-column> -->
                <t-table-column
                  :label="$t('resource.REMARKS_ADD.REMARKS')"
                  prop="aodProdRemarksSum"
                  :class-name="'cell_txt_center input_font_small'"
                  :width="getRemarksColumnWidthProc()"
                >
                  <template slot-scope="scope">
                    <div v-if="scope.row.id < 10000" class="bikouDiv">
                      <!-- 備考表示 -->
                      <span class="bikouText">
                        {{ scope.row.aodProdRemarksSum }}
                      </span>
                      <!-- 備考編集 -->
                      <t-button
                        type="warning"
                        icon="el-icon-edit"
                        size="small"
                        class="bikouButton"
                        circle
                        :disabled="isDLUserLocal"
                        @click="showRemarksDialogProc(scope.row, $event)"
                      ></t-button>
                    </div>
                  </template>
                </t-table-column>
                <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑ -->
                <!-- ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑ -->
              </t-table>
            </div>
          </t-col>
        </t-row>
      </div>

      <div :style="{ height: bottomHeight + 'px' }">
        <t-row class="marginBottom">
          <t-col :span="14">&nbsp;</t-col>

          <!-- 注文数 -->
          <t-col :span="5" class="col_common_right"
            ><t-input
              v-model="odOrderQtySum"
              style="margin-top: 5px"
              :disabled="true"
              class="sumInput"
            >
              <template slot="prepend">
                <span class="span_style">{{
                  $t("resource.ORDER.OD_ORDER_QTY_SUM")
                }}</span></template
              >
            </t-input></t-col
          >

          <!-- 合計(JPY) -->
          <t-col :span="5" class="col_common_right"
            ><t-input
              v-model="odTotalSum"
              style="margin-left: 20px; margin-top: 5px; text-align: right"
              :disabled="true"
              class="sumInput"
            >
              <template slot="prepend">
                <span class="span_style">{{
                  $t("resource.ORDER.OD_TOTAL_SUM")
                }}</span></template
              >
            </t-input></t-col
          >

          <!-- <t-col :span="2" v-if="isDaLianFac">&nbsp;</t-col>
          <t-col :span="11" v-else>&nbsp;</t-col> -->

          <!-- 合計(JPY) -->
          <!-- <t-col :span="4" class="col_common_right"
            ><t-input
              v-model="odTotalSum"
              style="margin-top: 5px; text-align: right"
              :disabled="true"
              class="sumInput"
            >
              <template slot="prepend">
                <span class="span_style">{{
                  $t("resource.ORDER.OD_TOTAL_SUM")
                }}</span></template
              >
            </t-input></t-col
          > -->
          <!-- 注文数 -->
          <!-- <t-col :span="4" class="col_common_right"
            ><t-input
              v-model="odOrderQtySum"
              style="margin-left: 20px; margin-top: 5px"
              :disabled="true"
              class="sumInput"
            >
              <template slot="prepend">
                <span class="span_style">{{
                  $t("resource.ORDER.OD_ORDER_QTY_SUM")
                }}</span></template
              >
            </t-input></t-col
          > -->
          <!-- 検査室入荷数 -->
          <!-- <t-col :span="5" class="col_common_right" v-if="isDaLianFac"
            ><t-input
              v-model="odCheckQtySum"
              style="margin-left: 20px; margin-top: 5px"
              :disabled="true"
              class="sumInput"
            >
              <template slot="prepend">
                <span class="span_style">{{
                  $t("resource.ORDER.OD_CHECK_QTY_SUM")
                }}</span></template
              >
            </t-input></t-col
          > -->
          <!-- 運送数 -->
          <!-- <t-col :span="4" class="col_common_right" v-if="isDaLianFac"
            ><t-input
              v-model="odTransQtySum"
              style="margin-left: 20px; margin-top: 5px"
              :disabled="true"
              class="sumInput"
            >
              <template slot="prepend">
                <span class="span_style">{{
                  $t("resource.ORDER.OD_TRANS_QTY_SUM")
                }}</span></template
              >
            </t-input></t-col
          > -->
          <!-- 日本入荷数 -->
          <!-- <t-col :span="5" class="col_common_right"
            ><t-input
              v-model="odReceQtySum"
              style="margin-left: 20px; margin-top: 5px"
              :disabled="true"
              class="sumInput"
            >
              <template slot="prepend">
                <span class="span_style">{{
                  $t("resource.ORDER.OD_RECE_QTY_SUM")
                }}</span></template
              >
            </t-input></t-col
          > -->
        </t-row>
        <t-row>
          <!--DEL 2024/12/16 ZLL 課题_受注製品変更の検討 start↓ -->
          <!-- <t-col :span="4" class="col_common_left"> -->
          <!-- 製品クローズ選択ボタン -->
          <!-- <t-button
              round
              type="primary"
              class="dialogButton_180_40"
              :disabled="localIsAdd"
              ref="productCloseSelectBtn"
              @click="productCloseSelectBtnProc"
            >
              <i class="el-icon-zoom-in"></i
              >{{ $t("resource.ACCEPT_ORDER.PRODUCT_CLOSE_SELECT") }}
            </t-button></t-col
          > -->
          <!--DEL 2024/12/16 ZLL 課题_受注製品変更の検討 start↓ -->

          <!-- UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓ -->
          <!-- 課題_納期分割機能の追加 -->
          <!-- <t-col :span="3" class="col_common_left"> -->
          <!-- 再入荷ボタン -->
          <!--UPD 2024/12/16 ZLL 課题_受注製品変更の検討 start↓ -->
          <!-- <t-button
              round
              type="primary"
              class="dialogButton_180_40"
              :disabled="localIsAdd"
              ref="restockBtn"
              @click="restockBtnProc"
            > -->
          <!-- <t-button
              round
              type="primary"
              class="dialogButton_180_40"
              :disabled="localIsAdd || this.quoteType === '3'"
              ref="restockBtn"
              @click="restockBtnProc"
            > -->
          <!--UPD 2024/12/16 ZLL 課题_受注製品変更の検討 end↑ -->
          <!-- <i class="el-icon-s-order"></i>{{ $t("resource.ORDER.RESTOCK") }}
            </t-button></t-col
          >-->
          <t-col :span="3">&nbsp;</t-col>
          <!-- UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑ -->

          <!--UPD 2024/12/16 ZLL 課题_受注製品変更の検討 start↓ -->
          <!-- <t-col :span="14" class="right">&nbsp;</t-col> -->
          <t-col :span="18" class="right">&nbsp;</t-col>
          <!--UPD 2024/12/16 ZLL 課题_受注製品変更の検討 end↑ -->
          <t-col :span="3" class="right">
            <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓ -->
            <!-- 品質保証部の権限を追加する -->

            <!-- <t-button
              round
              type="warning"
              class="dialogButton_confirm_120_40"
              ref="confirmBtn"
              @click="orderConfirm"
              :disabled="btnConfirmFlg"
            > -->
            <t-button
              round
              type="warning"
              class="dialogButton_confirm_120_40"
              ref="confirmBtn"
              @click="orderConfirm"
              :disabled="btnConfirmFlg || isDLUserLocal"
            >
              <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑ -->

              <i class="el-icon-check"></i>
              {{ $t("resource.COMMON_CONSTANT.CONFIRM") }}</t-button
            >
          </t-col>
          <t-col :span="1">&nbsp;</t-col>
        </t-row>
      </div>
    </t-card>
  </div>
</template>
<script>
import { getUserInfo } from "@/auth";
import {
  ShowInternalProcessCostDialog,
  ShowOrderDateSelectDialog,
  ShowOrderProdSelectDialog,
  ShowProductCloseSelectInOrderDialog,
  ShowRestockDialog,
} from "@/components/Dialog";
import { t } from "@/locales";
import { showRemarksDialog } from "@/services/common";
import {
  addOrderDetail,
  getInitInfoList,
  searchOrderDetailByOrderNo,
  searchOrderProcSupCode,
  updateOrderDetail,
} from "@/services/order";
import {
  cmpBasicData,
  cmpDetailData,
  formatCurDateToString,
  formatCurrencyToNumber,
  formatDateStrToString,
  formatDateToString,
  formatRemarksShow,
  formatStringToCurrency,
  formatStringToWeight,
  formatUndefinedToDate,
  getAbleDestinationList,
  getAbleSupplierInfoList,
  getAbleUserInfoList,
  getDialogContentHeight,
  getEditColWidthArr,
  getIconType,
  getRemarksColumnWidth,
  ShowMergeExKbn,
} from "@/utils/comFunction";
import {
  CONNECTOR_SHORT_LINE,
  DIALOG_LINE_HEIGHT,
  FACTORY_KBN_CPY,
  FACTORY_KBN_DALIAN,
  FACTORY_KBN_JAPAN,
  NORMAL_PROD,
  NUM_TWO,
  NUM_ZERO,
  STR_EMPTY,
  STR_HYPHEN,
  STR_ONE,
  STR_THREE,
  STR_TWO,
  STR_ZERO,
  UNIT_SET,
} from "@/utils/const";
import { Message, Modal } from "@tellus/component";
export default {
  data() {
    return {
      //比較用基本情報
      cmpBasicResult: {},
      //比較用明細情報
      cmpDetailResult: {},
      //読み込み回数
      numLoads: 1,

      activeNames: ["orderBasic"],

      //仕入先リスト
      supplierCpyList: [],
      //仕入先リスト(全て仕入先)
      supplierCpyAllList: [],

      //支払状態リスト
      paymentStatusList: [],

      //注文状態リスト
      orderStatusList: [],

      //プロセス区分リスト
      procKbnList: [],

      //輸送方式
      transMethodList: [],

      // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
      // 目的港の追加
      // 目的港リスト
      destinationList: [],
      // 目的港利用可能フラグ
      obDestPortFlg: false,
      // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑

      //製品異常区分
      prodExKbnList: [],

      //担当者リスト
      connecterList: [],

      //クローズ状態リスト
      closeStateList: [],

      //注文書出力ボタン　true:使用不可　false:使用可能
      buttonClickFlag: true,

      //受注一覧選択ボタン true:使用不可　false:使用可能
      btnOrdSelectFlag: false,

      //社内加工原価ボタン使用フラグ　true:使用不可　false:使用可能
      btnInternalSelectFlag: true,

      //確定ボタン使用フラグ　true:使用不可　false:使用可能
      btnConfirmFlg: false,

      // ADD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 start↓
      allUrgentFlg: false,
      // ADD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 end↑

      //画面フラグ　true:新規　false:編集
      localIsAdd: this.isAdd,

      // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
      //手配日編集フラグ　　true:使用不可　false:使用可能
      orderDateFlg: this.isAdd,
      // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

      //注文編集情報
      orderEditForm: {
        obQuoteNo: STR_EMPTY, //見積No.
        obOrderNoShow: STR_EMPTY, //注文基本情報_注文No.
        obOrderNo: STR_EMPTY, //注文基本情報_注文No.連番
        obSupCode: STR_EMPTY, // 仕入先
        obSupCodeBak: STR_EMPTY, // 仕入先バックアップ
        obSupFacKbn: STR_EMPTY, // 仕入先工場区分
        obDate: STR_EMPTY, // 注文日（保存用）
        // DEL 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 納期、注番の変更(見積単位⇒製品単位に変更)
        //obDueDate: STR_EMPTY, // 仕入先納期（保存用）
        // DEL 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
        obStatus: STR_EMPTY, // 注文状態
        obPayStatus: STR_EMPTY, // 支払状態
        obUserCode: STR_EMPTY, // 担当者
        obProcKbn: STR_EMPTY, //プロセス区分
        obTransMethod: STR_EMPTY, //輸送方式
        // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
        // 目的港の追加
        obDestinationCode: STR_EMPTY, //目的港
        // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑
        obUpdateTime: STR_EMPTY, //更新時間
      },

      //編集可能列
      //UPD 2025/01/02 Wzc 課題_仕様変更の対応 Start↓
      //editableColumns: ["odUPrice"],
      editableColumns: ["odUPrice", "odUPriceCNY"],
      //UPD 2025/01/02 Wzc 課題_仕様変更の対応 End↑

      //注文詳細製品(データ表示用)
      productInfoTable: [],

      // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
      tableKey: 0,
      // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

      // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
      //注文詳細製品(データ保存用)
      orderDetailInfo: [],
      //　見積ターブル　0：製品、1：設計、3：補足
      quoteType: "0",
      quoteTypeVal: "",
      // 見積ターブルリスト
      quoteTypeList: [],
      // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

      //日本仕入先の表示列
      columns: [],

      supCurrency: "",

      factoryKbn: "",

      //注文詳細製品一覧項目
      allColumns: [
        {
          // 品名
          prop: "odProdName",
          label: t("resource.COMMON_CONSTANT.PRODUCT_NAME"),
          // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
          // width: t("widgetSize.tableCommon.defaultWidth"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 画面と文字サイズの調整
          // width: t("widgetSize.tableCommon.width170"),
          width: t("widgetSize.tableCommon.width130"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 図番
        {
          prop: "odProdDrawNo",
          label: t("resource.COMMON_CONSTANT.PICTURE_NO"),
          // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
          // width: t("widgetSize.tableCommon.defaultWidth"),
          width: t("widgetSize.tableCommon.width120"),
          // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 start↓
        // 手配数位置の変更：「単位」列の前に移動する
        // 注文数
        {
          prop: "odProdQuantity",
          label: t("resource.ORDER.ORDER_QTY"),
          width: t("widgetSize.COMMON_WIDTH.EIGHTY"),
          class: "cell_txt_right",
        },
        // ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 end↑
        // 単位
        {
          prop: "odProdUnit",
          label: t("resource.COMMON_CONSTANT.UNIT"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 画面と文字サイズの調整
          // width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          width: t("widgetSize.COMMON_WIDTH.SIXTY"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          class: "cell_txt_center",
          overflowTooltip: true,
        },

        // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 製品の形状の追加
        // 形状
        {
          prop: "odProdShape",
          label: t("resource.COMMON_CONSTANT.SHAPE"),
          width: t("widgetSize.COMMON_WIDTH.EIGHTY"),
          class: "cell_txt_center",
          overflowTooltip: true,
        },
        // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
        // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
        // 緊急度の追加
        {
          // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
          // 手配の場合、緊急度が編集可能の変更
          // prop: "aodUrgent",
          prop: "aodUrgentBool",
          // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
          label: t("resource.ACCEPT_ORDER.AOD_URGENT"),
          width: t("widgetSize.tableCommon.width60"),
          align: "center",
        },

        // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
        // 目的港の追加
        {
          prop: "odDpName",
          label: t("resource.ORDER.DESTINATION_PORT"),
          width: t("widgetSize.tableCommon.width80"),
          align: "left",
          overflowTooltip: true,
        },
        // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑
        // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
        // DEL 2025/03/19 ZLL 課題_形状、素材、処理を削除したい start↓
        // // 形状
        // {
        //   prop: "odProdShape",
        //   label: t("resource.COMMON_CONSTANT.SHAPE"),
        //   width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
        //   class: "cell_txt_center",
        //   overflowTooltip: true,
        // },
        // // 素材
        // {
        //   prop: "odProdMaterial",
        //   label: t("resource.COMMON_CONSTANT.MATERIAL"),
        //   width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
        //   class: "cell_txt_left",
        //   overflowTooltip: true,
        // },
        // // 処理
        // {
        //   prop: "odProdTreatment",
        //   label: t("resource.COMMON_CONSTANT.TREATMENT"),
        //   width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
        //   class: "cell_txt_left",
        //   overflowTooltip: true,
        // },
        // DEL 2025/03/19 ZLL 課題_形状、素材、処理を削除したい end↑

        // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
        // ミスミ関連区分
        {
          prop: "aodMisumiKbnStr",
          label: t("resource.ORDER.MSM_KBN"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
        },
        // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑

        // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 納期、注番の変更(見積単位⇒製品単位に変更)
        // 仕入先納期
        {
          prop: "odDueDate",
          label: t("resource.ORDER.OD_DUE_DATE"),
          width: t("widgetSize.tableCommon.width160"),
          class: "cell_txt_center",
        },
        // 仕入先納期履歴
        {
          prop: "odDueDateHistory",
          label: t("resource.ORDER.OD_DUE_DATE_HISTORY"),
          width: t("widgetSize.tableCommon.width150"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },

        // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 start↓
        // 課題_打合状態、納期の追加
        // 得意先納期
        {
          prop: "aodCusDeliveryDateShow",
          label: t("resource.ORDER.CUSTOMER_DELIVERY_DATE"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
        },
        // 得意先納期履歴
        {
          prop: "aodCusDeliveryDateHistory",
          label: t("resource.ORDER.CUSTOMER_DELIVERY_DATE_HISTORY"),
          width: t("widgetSize.tableCommon.width150"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 end↑

        // DEL 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 start↓
        // 手配数位置の変更：「単位」列の前に移動する
        // // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
        // // 注文数
        // {
        //   prop: "odProdQuantity",
        //   label: t("resource.ORDER.ORDER_QTY"),
        //   // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        //   // 画面と文字サイズの調整
        //   // width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
        //   width: t("widgetSize.COMMON_WIDTH.EIGHTY"),
        //   // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
        //   class: "cell_txt_right",
        // },
        // DEL 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 end↑

        // // 受注クローズ数
        // {
        //   prop: "odAcceptCloseQty",
        //   label: t("resource.ORDER.ACCEPT_CLOSE_QTY"),
        //   // width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
        //   width: 120,
        //   class: "cell_txt_right",
        // },
        //ADD 2025/01/02 Wzc 課題_仕様変更の対応 Start↓
        // 加工単価(CNY)
        {
          prop: "odUPriceCNY",
          label: t("resource.ORDER.PROCESS_UNIT_CNY"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 画面と文字サイズの調整
          // width: t("widgetSize.ORDER.COLUMN_WIDTH_140"),
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TWENTY"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          class: "cell_txt_right",
        },
        //ADD 2025/01/02 Wzc 課題_仕様変更の対応 End↑
        // 加工単価(JPY)
        {
          prop: "odUPrice",
          label: t("resource.ORDER.PROCESS_UNIT"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 画面と文字サイズの調整
          // width: t("widgetSize.ORDER.COLUMN_WIDTH_140"),
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TWENTY"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          class: "cell_txt_right",
        },
        //ADD 2025/01/02 Wzc 課題_仕様変更の対応 Start↓
        // 小計(CNY)
        {
          prop: "odTotalCNY",
          label: t("resource.ORDER.SUBTOTAL_CNY"),
          // width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 画面と文字サイズの調整
          // width: 120,
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          class: "cell_txt_right",
        },
        //ADD 2025/01/02 Wzc 課題_仕様変更の対応 End↑
        // 小計(JPY)
        {
          prop: "odTotal",
          label: t("resource.ORDER.SUBTOTAL"),
          // width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 画面と文字サイズの調整
          // width: 120,
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          class: "cell_txt_right",
        },

        // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
        // 手配日
        {
          prop: "odDate",
          label: t("resource.ORDER.ORDER_DATE"),
          // width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 画面と文字サイズの調整
          // width: 120,
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          class: "cell_txt_center",
        },
        // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

        // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 start↓
        // 課題_検査室入荷日の追加
        // 検査室入荷日
        {
          prop: "odCheckRcvDateStr",
          label: t("resource.ORDER.CHECK_RCV_DATE"),
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED"),
          class: "cell_txt_center",
        },
        // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 end↑

        // 検査室入荷件数
        {
          prop: "odSizeCheckOkQty",
          label: t("resource.ORDER.INSPECTRCV_COUNT"),
          // width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 画面と文字サイズの調整
          // width: 120,
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          class: "cell_txt_right",
        },
        // 運送件数
        {
          prop: "odTransQty",
          label: t("resource.ORDER.TRANSPORT_COUNT"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 画面と文字サイズの調整
          // width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          width: t("widgetSize.COMMON_WIDTH.EIGHTY"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          class: "cell_txt_right",
        },
        // 日本入荷件数
        {
          prop: "odReceOkQty",
          label: t("resource.ORDER.OFFICERCV_COUNT"),
          // width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 画面と文字サイズの調整
          // width: 120,
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          class: "cell_txt_right",
        },
        // 支払状態
        {
          prop: "odPayStatusStr",
          label: t("resource.ORDER.PAYMENT_STATUS"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 画面と文字サイズの調整
          // width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          width: t("widgetSize.COMMON_WIDTH.EIGHTY"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          class: "cell_txt_center",
        },

        // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 start↓
        // 課題_打合状態、納期の追加
        // 打合状態
        {
          prop: "aodDiscussStatus",
          label: t("resource.ACCEPT_ORDER.PROD_DISCUSS_STATUS"),
          width: t("widgetSize.tableCommon.width80"),
          class: "cell_txt_center",
        },
        // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 end↑

        // DEL 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
        // クローズ状態
        // {
        //   prop: "odCloseState",
        //   label: t("resource.ACCEPT_ORDER.CLOSE_STATE"),
        //   width: t("widgetSize.tableCommon.defaultWidth"),
        //   class: "cell_txt_center",
        // },
        // DEL 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

        // // 製品異常区分
        // {
        //   prop: "odProdExKbnStr",
        //   label: t("resource.ORDER.PRODUCT_EX_KBN"),
        //   // width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
        //   width: 120,
        //   class: "cell_txt_center",
        // },
        // // 異常件数
        // {
        //   prop: "odProdExQty",
        //   label: t("resource.ORDER.PRODUCT_EX_QTY"),
        //   width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
        //   class: "cell_txt_right",
        // },
        // // クローズ件数
        // {
        //   prop: "odProdCloseQty",
        //   label: t("resource.ORDER.PRODUCT_CLOSE_QTY"),
        //   width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
        //   class: "cell_txt_right",
        // },
        // // 補足件数
        // {
        //   prop: "odProdSuppQty",
        //   label: t("resource.ORDER.PRODUCT_SUPP_QTY"),
        //   width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),

        //   class: "cell_txt_right",
        // },
        // // 補足支払数
        // {
        //   prop: "odProdSuppPayQty",
        //   label: t("resource.ORDER.PRODUCT_SUPP_PAY_QTY"),
        //   width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
        //   class: "cell_txt_right",
        // },

        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 課題_備考機能の追加
        // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
        // // 備考
        // {
        //   prop: "odProdRemarks",
        //   label: t("resource.ORDER.REMARKS"),
        //   width: t("widgetSize.tableCommon.width170"),
        //   class: "cell_txt_left",
        // },

        // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

        // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
        // 課題_納期分割機能の追加
        // 異常区分
        {
          prop: "odProdExKbnStr",
          label: t("resource.ACCEPT_ORDER.PRODUCT_EX_KBN"),
          width: t("widgetSize.tableCommon.width90"),
          class: "cell_txt_center",
        },

        // 削減状態
        {
          prop: "odReduceKbn",
          label: t("resource.DUE_DATE_EDIT.CLOSE_STATE"),
          width: t("widgetSize.tableCommon.width50"),
          class: "cell_txt_center",
        },

        // クローズ状態
        {
          prop: "odCloseStateBool",
          label: t("resource.ACCEPT_ORDER.CLOSE_STATE"),
          width: t("widgetSize.tableCommon.width70"),
          class: "cell_txt_center",
        },
        // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
      ],

      // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 課題_備考機能の追加
      //基本情報のheight
      // basicHeight: 49 + DIALOG_LINE_HEIGHT * 4,
      //明細情報のheight 20:Tableと合計行の間隔調整用(Table的marginTop + bottom)
      // detailHeight: getDialogContentHeight(
      //   window.innerHeight,
      //   49 + DIALOG_LINE_HEIGHT * 4,
      //   DIALOG_LINE_HEIGHT * 2,
      //   40
      // ),
      //基本情報のheight
      basicHeight: 49 + DIALOG_LINE_HEIGHT * 3,
      //明細情報のheight 20:Tableと合計行の間隔調整用(Table的marginTop + bottom)
      detailHeight: getDialogContentHeight(
        window.innerHeight,
        49 + DIALOG_LINE_HEIGHT * 3,
        DIALOG_LINE_HEIGHT * 2,
        40
      ),
      // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

      //合計情報のheight
      bottomHeight: DIALOG_LINE_HEIGHT * 2,

      //列の幅
      colArr: getEditColWidthArr(window.innerWidth, 4),

      //待ちダイアログ　true:表示　false:表示しない
      showFlag: false,

      //合計
      odTotalSum: NUM_ZERO,
      //注文数
      odOrderQtySum: NUM_ZERO,
      //検査室入荷数
      // odCheckQtySum: NUM_ZERO,
      //運送数
      // odTransQtySum: NUM_ZERO,
      //日本入荷数
      // odReceQtySum: NUM_ZERO,
      //仕入先は大連工場の場合
      isDaLianFac: true,

      //輸送方式 true:変更不可能　false:変更可能
      obTransMethodFlg: false,

      // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
      // 共通備考の調整（備考更新時刻）
      aodUpdateTime: null,
      // 品質保証部の権限を追加する
      isDLUserLocal: false,
      // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑

      // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
      ASetDataFlg: false,
      // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
      // ADD 2026/10/10 Wjx フロント画面コントロールのロードの最適化 start↓
      editingColumn: "",
      editingList: [
        //仕入先納期
        {
          value: "odDueDate",
          label: t("resource.ORDER.OD_DUE_DATE"),
        },
        //加工単価(CNY)
        {
          value: "odUPriceCNY",
          label: t("resource.ORDER.PROCESS_UNIT_CNY"),
        },
        //加工単価(JPY)
        {
          value: "odUPrice",
          label: t("resource.ORDER.PROCESS_UNIT"),
        },
      ],
      // ADD 2026/10/10 Wjx フロント画面コントロールのロードの最適化 end↑
    };
  },

  props: {
    //true:新規作成　false:編集
    isAdd: {
      Type: Boolean,
      default: false,
    },
    //行データ
    rowData: {
      Type: Object,
    },
  },

  mounted() {
    // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
    // 品質保証部の権限を追加する
    this.isDLUserLocal = sessionStorage.getItem("isDLUser") === "true";
    // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑

    //画面情報初期化
    this.init();

    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);
  },

  watch: {
    "orderEditForm.obSupCode"(val) {
      //工場区分
      var facKbn = this.supplierCpyList.find(
        (it) => it.supCode === val
      )?.supFactoryKbn;
      this.orderEditForm.obSupFacKbn = facKbn;
      //仕入先は本社の場合、社内加工原価ボタンが使用可能に変更
      if (facKbn === FACTORY_KBN_CPY) {
        this.btnInternalSelectFlag = false;
      } else {
        this.btnInternalSelectFlag = true;
      }
      //大連工場の場合
      if (facKbn === FACTORY_KBN_DALIAN) {
        //UPD 2025/01/02 Wzc 課題_仕様変更の対応 Start↓
        //this.columns = this.allColumns;

        this.columns = this.allColumns.filter((column) => {
          // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
          if (this.quoteType !== STR_THREE) {
            // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
            return (
              //加工単価(JPY)と小計(JPY)が表示しない
              column.prop !== "odUPrice" && column.prop !== "odTotal"
            );
            // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
          } else {
            //検査室入荷数と運送数と加工単価(JPY)と小計(JPY)と日本入荷件数が表示しない
            return (
              column.prop !== "odUPrice" &&
              column.prop !== "odTotal" &&
              column.prop !== "odSizeCheckOkQty" &&
              // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 start↓
              // 課題_検査室入荷日の追加
              // 金額調整のデータ、検査室入荷日を表示しない
              column.prop !== "odCheckRcvDateStr" &&
              // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 end↑
              column.prop !== "odTransQty" &&
              // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
              // 課題_納期分割機能の追加
              column.prop !== "odProdExKbnStr" && // 異常区分
              column.prop !== "odReduceKbn" && // 削減状態
              column.prop !== "odCloseStateBool" && // クローズ状態
              // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
              column.prop !== "odReceOkQty"
            );
          }
          // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
        });

        // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
        //UPD 2025/01/02 Wzc 課題_仕様変更の対応 End↑

        //合計表示用
        this.isDaLianFac = true;

        //輸送方式
        // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
        // this.orderEditForm.obTransMethod = this.transMethodList[0].value;
        this.orderEditForm.obTransMethod =
          this.orderEditForm.obTransMethod === ""
            ? this.transMethodList[0].value
            : this.orderEditForm.obTransMethod;
        // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
        this.obTransMethodFlg = false;
      } else {
        //大連以外工場の場合、一覧に検査室入荷数と運送数が表示しない
        this.columns = this.allColumns.filter((column) => {
          // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 start↓
          // 課題_打合状態、納期の追加
          // プロセス区分が加工以外の場合、打合状態を表示しない
          if (this.orderEditForm.obProcKbn != STR_ONE) {
            return (
              //検査室入荷数と運送数と加工単価(CNY)と小計(CNY)と検査室入荷日と打合状態が表示しない
              column.prop !== "odSizeCheckOkQty" &&
              column.prop !== "odTransQty" &&
              column.prop !== "odUPriceCNY" &&
              column.prop !== "odCheckRcvDateStr" &&
              column.prop !== "aodDiscussStatus" &&
              column.prop !== "odTotalCNY"
            );
          }
          // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 end↑
          // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
          //　通常製品の場合
          if (this.quoteType !== STR_THREE) {
            // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
            // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
            // return (
            //   //UPD 2025/01/02 Wzc 課題_仕様変更の対応 Start↓
            //   //column.prop !== "odSizeCheckOkQty" && column.prop !== "odTransQty"
            //   //検査室入荷数と運送数と加工単価(CNY)と小計(CNY)が表示しない
            //   column.prop !== "odSizeCheckOkQty" &&
            //   column.prop !== "odTransQty" &&
            //   column.prop !== "odUPriceCNY" &&
            //   // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 start↓
            //   // 課題_検査室入荷日の追加
            //   // 大連以外工場のデータ、検査室入荷日を表示しない
            //   column.prop !== "odCheckRcvDateStr" &&
            //   // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 end↑

            //   column.prop !== "odTotalCNY"
            //   //UPD 2025/01/02 Wzc 課題_仕様変更の対応 End↑
            // );
            var supAbbreviation = this.supplierCpyList.find(
              (it) => it.supCode === val
            )?.supAbbreviation;

            if (supAbbreviation.includes("ミスミ")) {
              return (
                //運送数と加工単価(CNY)と小計(CNY)が表示しない
                column.prop !== "odTransQty" &&
                column.prop !== "odUPriceCNY" &&
                column.prop !== "odTotalCNY"
              );
            } else {
              return (
                //検査室入荷数と運送数と加工単価(CNY)と小計(CNY)が表示しない
                column.prop !== "odSizeCheckOkQty" &&
                column.prop !== "odTransQty" &&
                column.prop !== "odUPriceCNY" &&
                // 大連以外工場のデータ、検査室入荷日を表示しない
                column.prop !== "odCheckRcvDateStr" &&
                column.prop !== "odTotalCNY"
              );
            }
            // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑

            // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
          } else {
            //　金額調整製品の場合
            return (
              //検査室入荷数と運送数と加工単価(CNY)と小計(CNY)と日本入荷件数が表示しない
              column.prop !== "odSizeCheckOkQty" &&
              column.prop !== "odTransQty" &&
              column.prop !== "odUPriceCNY" &&
              // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 start↓
              // 課題_検査室入荷日の追加
              // 金額調整のデータ、検査室入荷日を表示しない
              column.prop !== "odCheckRcvDateStr" &&
              // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 end↑
              // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
              // 課題_納期分割機能の追加
              column.prop !== "odProdExKbnStr" && // 異常区分
              column.prop !== "odReduceKbn" && // 削減状態
              column.prop !== "odCloseStateBool" && // クローズ状態
              // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
              column.prop !== "odTotalCNY" &&
              column.prop !== "odReceOkQty"
            );
          }

          // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
        });
        //合計表示用　検査室入荷数と合計数を表示しない
        this.isDaLianFac = false;

        //大連以外工場の場合、輸送方式が空です
        this.orderEditForm.obTransMethod = STR_EMPTY;
        this.obTransMethodFlg = true;

        // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
        // 目的港の追加
        // 大連以外工場の場合、目的港が空です
        this.orderEditForm.obDestinationCode = STR_EMPTY;
        // 目的港がクリック不可
        this.obDestPortFlg = true;

        // 詳細一覧の目的港名の更新
        this.productInfoTable.forEach((row) => {
          row.odDpName = STR_HYPHEN;
          row.odDestinationCode = STR_EMPTY;
        });
        // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑
      }
      // setColumnWidth(this.columns, this.productInfoTable);
    },

    // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
    // 課題_備考機能の追加
    quoteType(newVal) {
      this.handleResize();
    },

    // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
    // 目的港の追加
    // 基本情報の目的港を変更した場合、詳細一覧のすべての目的港を連動変更する
    "orderEditForm.obDestinationCode"(val) {
      const selectedPort = this.destinationList.find(
        (item) => item.dpCode === val
      );
      const portName = selectedPort ? selectedPort.dpName : STR_HYPHEN;

      // 目的港名の更新
      this.productInfoTable.forEach((row) => {
        row.odDpName = portName;
        row.odDestinationCode = val;
      });
    },

    //輸送方式が「エアー便、空」の場合、選択不可; 輸送方式が「船便」の場合、選択必要
    "orderEditForm.obTransMethod"(val) {
      if (val == NUM_TWO) {
        this.obDestPortFlg = false;
      } else {
        //エアー便の場合、目的港が空です
        this.orderEditForm.obDestinationCode = STR_EMPTY;
        // 目的港がクリック不可
        this.obDestPortFlg = true;

        // 詳細一覧の目的港名の更新
        this.productInfoTable.forEach((row) => {
          row.odDpName = STR_HYPHEN;
          row.odDestinationCode = STR_EMPTY;
        });
      }
    },
    // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑
    // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
  },

  updated() {
    //Tableを再レンダリングする、スクロールバーを上に移動する問題を解決する
    this.$refs.productInfoTable.doLayout();
  },

  methods: {
    //注文明細情報の追加
    addOrderDetailProc() {
      this.showFlag = true;

      //保存前、データ処理
      this.dataAddUpdProc();

      addOrderDetail({
        orderBasicInfo: this.orderEditForm,
        // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
        // orderDetailInfoList: this.productInfoTable,
        orderDetailInfoList: this.orderDetailInfo,
        // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
        loginUser: getUserInfo().UserId,
      })
        .then((res) => {
          //注文No.連番の取得
          this.orderEditForm.obOrderNo = res;

          //新規⇒編集状態の変換
          this.localIsAdd = false;

          //受注製品選択ボタンが使用不可に変更
          this.btnOrdSelectFlag = true;
          //注文書出力ボタンが使用可能に変更
          this.buttonClickFlag = false;

          Message.showSuccess(t("message.COMMON_MESSAGE.ADD_SUCCESS"));

          this.numLoads = 1;

          //検索処理を行う
          this.getOrderDetailByOrderNo();
        })
        .catch((err) => {
          this.showFlag = false;

          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.ADD_FAILURE"));
          }
        });
    },

    //合計データの計算(別に)
    calculateSumData(sumColumn) {
      var sumTmp = NUM_ZERO;
      this.productInfoTable.forEach((row) => {
        sumTmp += formatCurrencyToNumber(row[sumColumn]);
      });
      //UPD 2025/01/02 Wzc 課題_仕様変更の対応 Start↓
      //return formatStringToCurrency(sumTmp);
      //大連工場の場合、2桁の小数を表示する
      if (this.factoryKbn == FACTORY_KBN_DALIAN) {
        return formatStringToWeight(sumTmp);
      } else {
        return formatStringToCurrency(sumTmp);
      }
      //UPD 2025/01/02 Wzc 課題_仕様変更の対応 End↑
    },

    //セルデータの保存
    changeCellData(curRow) {
      //UPD 2025/01/02 Wzc 課題_仕様変更の対応 Start↓
      /*//小計
      curRow.odTotal = formatStringToCurrency(
        curRow.odUPrice * curRow.odProdQuantity
      );

      //加工単価
      curRow.odUPrice = formatStringToCurrency(curRow.odUPrice);

      //合計(JPY)
      this.odTotalSum = this.calculateSumData("odTotal");*/

      //大連工場の場合
      if (this.isDaLianFac == FACTORY_KBN_DALIAN) {
        //入力最大値：99999.99
        if (formatCurrencyToNumber(curRow.odUPriceCNY) > 99999.99) {
          curRow.odUPriceCNY = 99999.99;
        }

        //小計(CNY)
        curRow.odTotalCNY = formatStringToWeight(
          formatCurrencyToNumber(curRow.odUPriceCNY) * curRow.odProdQuantity
        );
        //加工単価(CNY)
        curRow.odUPriceCNY = formatStringToWeight(curRow.odUPriceCNY);

        //合計(CNY)
        this.odTotalSum = this.calculateSumData("odTotalCNY");
      } else {
        // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
        //小計
        // curRow.odTotal = formatStringToCurrency(
        // curRow.odUPrice * curRow.odProdQuantity
        // );
        curRow.odTotal = formatStringToCurrency(
          formatCurrencyToNumber(curRow.odUPrice) * curRow.odProdQuantity
        );
        // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

        //加工単価
        curRow.odUPrice = formatStringToCurrency(curRow.odUPrice);

        //合計(JPY)
        this.odTotalSum = this.calculateSumData("odTotal");
      }

      const rowIndex = this.productInfoTable.findIndex(
        (item) => item.id === curRow.id
      );
      if (rowIndex !== -1) {
        // 使用$set更新数据
        this.$set(this.productInfoTable, rowIndex, curRow);
      }
      //UPD 2025/01/02 Wzc 課題_仕様変更の対応 End↑
      // this.dataProcess();

      // setColumnWidth(this.columns, this.productInfoTable);
    },
    //セルデータの数字変換
    // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
    // changeCellDataToNumber(curRow, columnName) {
    changeCellDataToNumber(curRow, columnName, $event) {
      this.selectValue($event);
      // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
      curRow[columnName] = formatCurrencyToNumber(curRow[columnName]);
    },

    //input-numberの文字スタイル
    changeCellInputClass(row) {
      //正常製品の場合または新規の場合、黒い字を表示
      if (row.odProdExKbn == NUM_ZERO || this.localIsAdd) {
        return "input-cell-normal";
      } else {
        //赤い字を表示
        return "input-cell-ex";
      }
    },

    //クリア処理
    // clearClick(kbn) {
    //   //クリアの場合、仕入先をクリア
    //   if (kbn === "clear") {
    //     //仕入先コードのクリア
    //     this.orderEditForm.obSupCode = STR_EMPTY;
    //   }

    //   //注文No.のクリア
    //   this.orderEditForm.obOrderNoShow = STR_EMPTY;
    //   //注文明細のクリア
    //   this.productInfoTable = [];

    //   //新規、製品データがクリアする場合、確定ボタンが使用不可に変更
    //   this.btnConfirmFlg = true;
    // },

    // 注文詳細情報の更新
    updateOrderDetailProc() {
      this.showFlag = true;

      //入力チェック
      // if (!this.inputCheck()) {
      //   Message.showError(t("message.ORDER.CLOSE_QTY_ERR"));
      //   return;
      // }

      //保存前、データ処理
      this.dataAddUpdProc();

      // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
      // var tmpTableData = this.productInfoTable.map((item) => {
      var tmpTableData = this.orderDetailInfo.map((item) => {
        // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
        return {
          ...item,

          // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
          // 課題_納期分割機能の追加
          //クローズ状態の変換
          // odCloseState: this.closeStateList.find(
          //   (it) => it.label === item.odCloseState
          // )?.value,
          // odCloseState: item.odCloseStateBool ? STR_ONE : STR_ZERO, //クローズ区分
          // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
        };
      });

      //更新処理
      updateOrderDetail({
        orderBasicInfo: this.orderEditForm,
        orderDetailInfoList: tmpTableData,
        loginUser: getUserInfo().UserId,
      })
        .then((res) => {
          Message.showSuccess(t("message.COMMON_MESSAGE.UPDATE_SUCCESS"));

          this.numLoads = 1;
          //検索処理を行う
          this.getOrderDetailByOrderNo();
        })
        .catch((err) => {
          this.showFlag = false;

          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.UPDATE_FAILURE"));
          }
        });
    },

    // ダイアログを閉じる
    close() {
      this.$emit("cancel");
    },

    // 更新/追加されたデータ処理
    dataAddUpdProc() {
      //注文日
      this.orderEditForm.obDate = formatCurDateToString(
        this.orderEditForm.obDate
      );
      // DEL 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 納期、注番の変更(見積単位⇒製品単位に変更)
      // //仕入先納期
      // this.orderEditForm.obDueDate = formatCurDateToString(
      //   this.orderEditForm.obDueDate
      // );
      // DEL 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

      // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
      /*  this.productInfoTable.forEach((item, index) => {
        //見積No.
        item.odQuoteNo = this.orderEditForm.obQuoteNo;
        //注文No.
        item.odOrderNoShow = this.orderEditForm.obOrderNoShow;
        //注文No.連番
        item.odOrderNo = this.orderEditForm.obOrderNo;
        //注文明細No.
        item.odOrderDetailNo = index + 1;
        //注文製品明細No.
        item.odProdGroupNo = index + 1;
        //小計
        //item.odTotal = formatCurrencyToNumber(item.odTotal);

        //正常製品と新規の場合
        // if (item.odProdExKbnStr === NORMAL_PROD || this.localIsAdd) {
        //   //注文明細No.
        //   item.odOrderDetailNo = index + 1;
        // } else {
        //   //注文明細No.
        //   item.odOrderDetailNo = index;
        // }
        });*/

      this.orderDetailInfo = [];
      this.productInfoTable.forEach((item, index) => {
        // 見積No.
        var odQuoteNo = this.orderEditForm.obQuoteNo;
        // 注文No.
        var odOrderNoShow = this.orderEditForm.obOrderNoShow;
        // 注文No.連番
        var odOrderNo = this.orderEditForm.obOrderNo;

        // UPD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 start↓
        // if (item.childrenCount > 1) {
        // 課題_検査室入荷日の追加
        // 数量変更の手配データの数量
        var numChangeChildCount =
          item.children != null
            ? item.children.filter(
                (sonItem) => sonItem.id >= 10000 && sonItem.dataKbn === STR_ONE
              ).length
            : 0;
        if (numChangeChildCount > 1) {
          // UPD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 end↑
          item.children.forEach((element) => {
            // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 start↓
            // 課題_検査室入荷日の追加
            // データ区分が正常手配データの場合（1：正常手配データ（新規データ、数量変更の手配データ）、2：検査室入荷日別の手配データ）
            if (element.dataKbn === STR_ONE) {
              // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 end↑
              this.saveDataFormat(
                item,
                element,
                odQuoteNo,
                odOrderNoShow,
                odOrderNo,
                index
              );
            }
          });
        } else {
          this.saveDataFormat(
            item,
            item,
            odQuoteNo,
            odOrderNoShow,
            odOrderNo,
            index
          );
        }
      });

      // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
      // 課題_納期分割機能の追加
      this.orderDetailInfo.sort((a, b) => {
        return a.odOrderDetailNo - b.odOrderDetailNo;
      });
      // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
      // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
    },

    // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
    //データを保存のフォーマット
    saveDataFormat(item, element, odQuoteNo, odOrderNoShow, odOrderNo, index) {
      // 注文明細No.
      var odOrderDetailNo = index + 1;
      // 注文製品明細No.
      var odProdGroupNo = index + 1;
      this.orderDetailInfo.push({
        odQuoteNo: odQuoteNo, // 見積No.
        odProdNo: element.odProdNo, // 受注明細_受注明細No
        odOrderNoShow: odOrderNoShow, // 注文No.
        odOrderNo: odOrderNo, // 注文No.連番
        odQuoteType: element.odQuoteType, // 注文タイプ 1:製品、2:設計
        // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
        // 課題_納期分割機能の追加
        // odOrderDetailNo: odOrderDetailNo, // 注文明細No.
        // odProdGroupNo: odProdGroupNo, // 注文製品明細No.
        odOrderDetailNo: !!item.odOrderDetailNo
          ? item.odOrderDetailNo
          : odOrderDetailNo, // 注文明細No.
        odProdGroupNo: !!item.odProdGroupNo
          ? item.odProdGroupNo
          : odProdGroupNo, // 注文製品明細No.
        // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
        odQuoteChildNo: element.odQuoteChildNo ?? "00", // 見積No.子番
        odUPrice: item.odUPrice, // 加工単価
        odUPriceCNY: item.odUPriceCNY, // 加工単価(CNY)
        // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
        // 課題_納期分割機能の追加
        // odProdQuantity: element.odProdQuantity, // 数量
        odProdQuantity:
          item.odProdExKbn === STR_TWO ? NUM_ZERO : element.odProdQuantity, // 数量
        // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
        odCurType: item.odCurType, // 貨幣タイプ
        odExr: item.odExr, // レート
        // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 納期、注番の変更(見積単位⇒製品単位に変更)
        odDueDate: formatCurDateToString(item.odDueDate), //仕入先納期
        odDueDateHistory: item.odDueDateHistory, //仕入先納期履歴
        // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
        odMaterialCost: item.odMaterialCost,
        odMachineCost: item.odMachineCost,
        odProcess1Cost: item.odProcess1Cost,
        odProcess2Cost: item.odProcess2Cost,
        odProcess3Cost: item.odProcess3Cost,
        odProcess4Cost: item.odProcess4Cost,
        odInternalSumCost: item.odInternalSumCost,
        odProdExKbnStr: item.odProdExKbnStr,
        odProdName: item.odProdName,
        odProdDrawNo: item.odProdDrawNo,
        odProdExKbn: item.odProdExKbn,
        // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
        // 課題_納期分割機能の追加
        // odCloseState: element.odCloseState,
        odCloseState: item.odCloseStateBool ? STR_ONE : STR_ZERO, //クローズ区分
        // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
        // 手配の場合、緊急度が編集可能の変更
        aodUrgent: item.aodUrgentBool ? STR_ONE : STR_ZERO, // 緊急度
        // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
        odProdReceExKbn: item.odProdReceExKbn, //入荷異常区分
        // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
        odProdRemarks: element.odProdRemarks,

        odTotal: formatCurrencyToNumber(item.odUPrice) * element.odProdQuantity, // 小計
        odTotalCNY:
          formatCurrencyToNumber(item.odUPriceCNY) * element.odProdQuantity, // 小計(CNY)
        // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
        // 課題_納期分割機能の追加
        // odDate: this.orderDateFlg ? this.orderEditForm.obDate : element.odDate, // 手配日
        odDate: this.localIsAdd ? this.orderEditForm.obDate : element.odDate, // 手配日
        // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑

        // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
        // 目的港の追加
        odDestinationCode: item.odDestinationCode,
        // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑
      });
    },
    // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

    //データの変換処理
    dataProcess() {
      //1000.00　⇒　¥1,000.00
      if (this.productInfoTable.length >= 1) {
        // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 納期、注番の変更(見積単位⇒製品単位に変更)
        // 仕入先納期履歴の列幅フラグ（true:増加）
        var historyChangeWidth = false;

        // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 start↓
        // 得意先納期履歴の列幅フラグ（true:増加）
        var cusHistoryChangeWidth = false;
        // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 end↑
        // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

        for (let index = 0; index < this.productInfoTable.length; index++) {
          var element = this.productInfoTable[index];

          // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
          // 課題_納期分割機能の追加
          this.productInfoTable[index].odProdExKbnStr = ShowMergeExKbn(
            element.odProdExKbn,
            element.odProdReceExKbn
          );
          // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑

          //UPD 2025/01/02 Wzc 課題_仕様変更の対応 Start↓
          /*//加工単価が数字の場合
          if (!isNaN(element.odUPrice)) {
            // 小計
            this.productInfoTable[index].odTotal = formatStringToCurrency(
              element.odUPrice * element.odProdQuantity
            );

            // 加工単価
            this.productInfoTable[index].odUPrice = formatStringToCurrency(
              element.odUPrice
            );
          } else {
            //加工単価が数字以外の場合、0に表示する
            this.productInfoTable[index].odTotal = 0;
            this.productInfoTable[index].odUPrice = formatStringToCurrency(0);
          }*/

          // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
          // 課題_納期分割機能の追加
          //納品異常の場合、金額が０を表示
          if (element.odProdExKbn === STR_TWO) {
            this.productInfoTable[index].odUPriceCNY = 0; // 加工単価(CNY)
            this.productInfoTable[index].odTotalCNY = 0; // 小計(CNY)

            this.productInfoTable[index].odUPrice = 0; // 加工単価(CNY)
            this.productInfoTable[index].odTotal = 0; // 小計(CNY)
          }
          // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
          //大連工場の場合、加工単価(CNY)、小計(CNY)を使用する
          if (this.factoryKbn == FACTORY_KBN_DALIAN) {
            if (!isNaN(element.odUPriceCNY)) {
              // 小計(CNY)
              this.productInfoTable[index].odTotalCNY = formatStringToWeight(
                (element.odUPriceCNY || 0) * element.odProdQuantity
              );

              // 加工単価(CNY)
              this.productInfoTable[index].odUPriceCNY = formatStringToWeight(
                element.odUPriceCNY
              );
            } else {
              this.productInfoTable[index].odTotalCNY = 0;
              this.productInfoTable[index].odUPriceCNY =
                formatStringToCurrency(0);
            }
          } else {
            //日本工場の場合、加工単価(JPY)、小計(JPY)を使用する
            //加工単価が数字の場合
            if (!isNaN(element.odUPrice)) {
              // 小計
              this.productInfoTable[index].odTotal = formatStringToCurrency(
                element.odUPrice * element.odProdQuantity
              );

              // 加工単価
              this.productInfoTable[index].odUPrice = formatStringToCurrency(
                element.odUPrice
              );
            } else {
              //加工単価が数字以外の場合、0に表示する
              this.productInfoTable[index].odTotal = 0;
              this.productInfoTable[index].odUPrice = formatStringToCurrency(0);
            }
          }
          //UPD 2025/01/02 Wzc 課題_仕様変更の対応 End↑

          //クローズ状態の変換
          this.productInfoTable[index].odCloseState = this.closeStateList.find(
            (it) => it.value === this.productInfoTable[index].odCloseState
          )?.label;

          //検査室入荷数または日本入荷数 > 0の場合
          /*if (
            element.odSizeCheckOkQty > NUM_ZERO ||
            element.odReceOkQty > NUM_ZERO
          ) {
            //注文書出力ボタンが使用不可に変更
            this.buttonClickFlag = true;
          }*/

          //製品異常区分が0「正常製品」の場合⇒検討
          // if (element.odProdExKbn !== this.prodExKbnList[0].value) {
          //   //日本入荷異常の場合、加工単価と小計が「0」を表示する
          //   if (element.odProdExKbn === this.prodExKbnList[1].value) {
          //     this.productInfoTable[index].odUPrice = formatStringToCurrency(0);
          //     this.productInfoTable[index].odTotal = formatStringToCurrency(0);
          //   }
          // }

          // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
          // UPD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 start↓
          // 課題_検査室入荷日の追加
          // 数量変更の手配データの数量
          var childCount =
            this.productInfoTable[index].children != null
              ? this.productInfoTable[index].children.filter(
                  (item) => item.id >= 10000 && item.dataKbn === STR_ONE
                ).length
              : 0;
          // if (
          //   this.productInfoTable[index].children != null &&
          //   this.productInfoTable[index].children.length > 0
          // ) {
          if (this.productInfoTable[index].children != null && childCount > 0) {
            // UPD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 end↑

            //子項変更
            this.productInfoTable[index].children.forEach((entity) => {
              //受注日
              entity.odDate = formatDateToString(entity.odDate);
            });
          } else {
            this.productInfoTable[index].odDate = formatDateToString(
              this.productInfoTable[index].odDate
            );
          }
          // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
          // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 納期、注番の変更(見積単位⇒製品単位に変更)
          if (!this.localIsAdd) {
            // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
            // 品質保証部の権限を追加する
            if (this.isDLUserLocal) {
              //仕入先納期
              this.productInfoTable[index].odDueDate = formatDateStrToString(
                element.odDueDate
              );
            } else {
              // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑

              // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
              // 閉じる後、仕入先納期の変更チェック
              //仕入先納期
              // this.productInfoTable[index].odDueDate = formatUndefinedToDate(
              //   this.productInfoTable[index].odDueDate
              // );
              this.productInfoTable[index].odDueDate = formatDateToString(
                this.productInfoTable[index].odDueDate
              );
              // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
            }
          }
          //仕入先納期履歴
          this.productInfoTable[index].odDueDateHistory = this.isEmptyOrNull(
            this.productInfoTable[index].odDueDateHistory
          )
            ? CONNECTOR_SHORT_LINE
            : this.productInfoTable[index].odDueDateHistory;
          //仕入先納期履歴の列幅フラグ（true:増加）
          if (this.productInfoTable[index].odDueDateHistory.includes("→")) {
            historyChangeWidth = true;
          }
          // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

          // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 start↓
          // 課題_打合状態、納期の追加
          this.productInfoTable[index].aodCusDeliveryDateHistory =
            this.isEmptyOrNull(
              this.productInfoTable[index].aodCusDeliveryDateHistory
            )
              ? CONNECTOR_SHORT_LINE
              : this.productInfoTable[index].aodCusDeliveryDateHistory;

          //得意先納期履歴の列幅フラグ（true:増加）
          if (
            this.productInfoTable[index].aodCusDeliveryDateHistory.includes("→")
          ) {
            cusHistoryChangeWidth = true;
          }
          // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 end↑
        }

        // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 納期、注番の変更(見積単位⇒製品単位に変更)
        // 納期の列幅フラグ（true:増加）
        this.columns = this.columns.map((col) => {
          if (col.prop === "odDueDateHistory") {
            return { ...col, width: historyChangeWidth ? 210 : 120 };
          }
          // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 start↓
          if (col.prop === "aodCusDeliveryDateHistory") {
            return { ...col, width: cusHistoryChangeWidth ? 210 : 120 };
          }
          // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 end↑
          return col;
        });
        // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

        //読み込み回数=1
        if (this.numLoads == 1) {
          var tmpTableData = JSON.parse(JSON.stringify(this.orderEditForm));
          tmpTableData.obDate = formatDateToString(tmpTableData.obDate);
          // DEL 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 納期、注番の変更(見積単位⇒製品単位に変更)
          //tmpTableData.obDueDate = formatDateToString(tmpTableData.obDueDate);
          // DEL 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

          // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
          if (
            !tmpTableData.hasOwnProperty("obTransMethod") ||
            tmpTableData.obTransMethod == undefined ||
            tmpTableData.obTransMethod == null
          ) {
            tmpTableData.obTransMethod = String.STR_EMPTY;
          }
          // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
          //比較用基本情報
          this.cmpBasicResult = JSON.parse(
            JSON.stringify(this.extractBasic(tmpTableData))
          );

          //比較用詳細情報
          this.cmpDetailResult = JSON.parse(
            JSON.stringify(this.extractDetail(this.productInfoTable))
          );
          this.numLoads = this.numLoads + 1;
        }
      }

      //合計データの計算
      //this.calculateTotalData();

      //UPD 2025/01/02 Wzc 課題_仕様変更の対応 Start↓
      //合計(JPY)
      //this.odTotalSum = this.calculateSumData("odTotal");

      if (this.factoryKbn == FACTORY_KBN_DALIAN) {
        //合計(CNY)
        this.odTotalSum = this.calculateSumData("odTotalCNY");
      } else {
        //合計(JPY)
        this.odTotalSum = this.calculateSumData("odTotal");
      }

      //UPD 2025/01/02 Wzc 課題_仕様変更の対応 End↑
      //注文数
      // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
      // this.odOrderQtySum = this.calculateSumData("odProdQuantity");
      // UPD 2026/10/10 Wjx フロント画面コントロールのロードの最適化 start↓
      // エラー修正
      //this.odOrderQtySum = parseInt(this.calculateSumData("odProdQuantity"));
      this.odOrderQtySum = parseInt(
        this.calculateSumData("odProdQuantity").replace(/,/g, ""),
        10
      );
      // UPD 2026/10/10 Wjx フロント画面コントロールのロードの最適化 end↑
      // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

      //検査室入荷数
      // this.odCheckQtySum = this.calculateSumData("odSizeCheckOkQty");

      //運送数
      // this.odTransQtySum = this.calculateSumData("odTransQty");

      //日本入荷数
      // this.odReceQtySum = this.calculateSumData("odReceOkQty");

      // ADD 2025/04/02 ZLL 課題_250401顧客からの改善したい点への対応 start↓
      this.refreshTable();
      // ADD 2025/04/02 ZLL 課題_2500401顧客からの改善したい点への対応 end↑
    },

    //注文No.による注文詳細情報の取得
    getOrderDetailByOrderNo() {
      searchOrderDetailByOrderNo({ orderBasicInfo: this.orderEditForm })
        .then((res) => {
          //注文No.
          this.orderEditForm.obOrderNoShow =
            res.Result.orderBasicInfo.obOrderNoShow;
          //注文状態
          this.orderEditForm.obStatus = res.Result.orderBasicInfo.obStatus;
          //支払状態
          this.orderEditForm.obPayStatus =
            res.Result.orderBasicInfo.obPayStatus;
          //担当者
          this.orderEditForm.obUserCode = res.Result.orderBasicInfo.obUserCode;
          //仕入先
          this.orderEditForm.obSupCode = res.Result.orderBasicInfo.obSupCode;
          //仕入先コードバックアップ
          this.orderEditForm.obSupCodeBak = JSON.parse(
            JSON.stringify(res.Result.orderBasicInfo.obSupCode)
          );

          //輸送方式
          this.orderEditForm.obTransMethod =
            res.Result.orderBasicInfo.obTransMethod;

          // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
          // 目的港の追加
          // 目的港
          this.orderEditForm.obDestinationCode =
            res.Result.orderBasicInfo.obDestinationCode ?? "";
          // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑

          //注文日
          this.orderEditForm.obDate = formatUndefinedToDate(
            res.Result.orderBasicInfo.obDate
          );
          // DEL 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 納期、注番の変更(見積単位⇒製品単位に変更)
          // //仕入先納期
          // this.orderEditForm.obDueDate = formatUndefinedToDate(
          //   res.Result.orderBasicInfo.obDueDate
          // );
          // DEL 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

          //プロセス区分
          this.orderEditForm.obProcKbn = res.Result.orderBasicInfo.obProcKbn;

          //更新時刻
          this.orderEditForm.obUpdateTime =
            res.Result.orderBasicInfo.obUpdateTime;

          if (res.Result.orderDetailInfoList.length > NUM_ZERO) {
            //見積No.
            this.orderEditForm.obQuoteNo =
              res.Result.orderDetailInfoList[0].odQuoteNo;
          }
          this.productInfoTable = res.Result.orderDetailInfoList;
          // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
          // 共通備考の調整（備考更新時刻）
          if (
            res.Result.orderDetailInfoList != null &&
            res.Result.orderDetailInfoList.length != 0
          ) {
            this.aodUpdateTime =
              res.Result.orderDetailInfoList[0].aodUpdateTime;
          }
          // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
          // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
          this.orderDateFlg = this.productInfoTable.every(
            (item) => item.childrenCount === 1
          );
          //見積ターブルを変更
          if (
            !!this.productInfoTable &&
            this.productInfoTable[0].odQuoteType === STR_THREE
          ) {
            this.quoteType = STR_THREE;
            this.quoteTypeVal = this.quoteTypeList.find(
              (it) => it.value === this.quoteType
            )?.label;
          }
          // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

          // ADD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 start↓
          this.allUrgentFlg = this.productInfoTable.every(
            (item) => item.aodUrgentBool
          );
          // ADD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 end↑

          // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
          this.ASetDataFlg = this.productInfoTable.some(
            (row) => row.odProdUnit === UNIT_SET
          );
          // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑

          this.getAbleList();

          this.supCurrency = res.SupCurrency;
          this.factoryKbn = res.FactoryKbn;

          //仕入先リストに同じ「工場」の保持
          var kbnVals =
            this.factoryKbn == FACTORY_KBN_DALIAN
              ? [FACTORY_KBN_DALIAN]
              : [FACTORY_KBN_JAPAN, FACTORY_KBN_CPY];

          this.supplierCpyList = this.supplierCpyList.filter((item) =>
            kbnVals.includes(item.supFactoryKbn)
          );
          //列幅に自動調整
          // setColumnWidth(this.columns, this.productInfoTable);
          //書式処理
          this.dataProcess();
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(
              t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
            );
          }

          //確定ボタンが使用不可に変更
          this.btnConfirmFlg = true;
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    //テーブルの高さを設定する
    handleResize() {
      var val = this.activeNames;

      if (val.indexOf("orderBasic") !== -1) {
        // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 課題_備考機能の追加
        // this.basicHeight = 49 + DIALOG_LINE_HEIGHT * 4;
        // UPD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
        // 目的港の追加
        // this.basicHeight =
        //   this.quoteType === "3"
        //     ? 49 + DIALOG_LINE_HEIGHT * 4
        //     : 49 + DIALOG_LINE_HEIGHT * 3;
        this.basicHeight = 49 + DIALOG_LINE_HEIGHT * 4;
        // UPD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑

        // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
        this.detailHeight = getDialogContentHeight(
          window.innerHeight,
          this.basicHeight,
          DIALOG_LINE_HEIGHT * 2,
          40
        );
      } else {
        this.basicHeight = 49 + DIALOG_LINE_HEIGHT;

        this.detailHeight = getDialogContentHeight(
          window.innerHeight,
          this.basicHeight,
          DIALOG_LINE_HEIGHT * 2,
          30
        );
      }

      this.colArr = getEditColWidthArr(window.innerWidth, 4);
    },

    //折り畳みパネルの処理
    handleCollapseChange() {
      this.handleResize();
    },

    //Enter処理
    focusNextInput(index, columnProp) {
      // let columnIndex = this.editableColumns.indexOf(columnProp);

      // if (columnIndex == -1) {
      //   columnIndex = 0;
      // }

      // index = index + 1;

      // if (index > this.productInfoTable.length - 1) {
      //   this.$refs[`input${0}`][columnIndex].focus();
      // } else {
      //   this.$refs[`input${index}`][columnIndex].focus();
      // }

      index = index + 1;

      if (index > this.productInfoTable.length - 1) {
        for (var i = 0; i < this.productInfoTable.length; i++) {
          if (this.$refs[`input${i}-${columnProp}`] !== undefined) {
            this.$refs[`input${i}-${columnProp}`][0].focus();
            break;
          }
        }
      } else {
        var i = index;
        for (i; i < this.productInfoTable.length; i++) {
          if (this.$refs[`input${i}-${columnProp}`] !== undefined) {
            this.$refs[`input${i}-${columnProp}`][0].focus();
            break;
          }
        }
        //下に入力ボックスがない場合は、最初から
        if (i == this.productInfoTable.length) {
          this.focusNextInput(-1, columnProp);
        }
      }
    },

    // 初期化
    init() {
      this.showFlag = true;

      //注文情報の初期化
      this.infoInit();

      //列幅に自動調整
      // setColumnWidth(this.columns, this.productInfoTable);
    },

    //注文情報の初期化
    infoInit() {
      //基本情報のリスト取得（仕入先、担当者）
      getInitInfoList()
        .then((res) => {
          //仕入先リストの取得
          this.supplierCpyList = res.supplierCpyList;
          this.supplierCpyAllList = res.supplierCpyList;
          //支払状態
          this.paymentStatusList = res.obPayStatus;

          //注文状態
          this.orderStatusList = res.obStatus;

          //プロセス区分
          this.procKbnList = res.searchProcKbn;

          //製品異常区分
          this.prodExKbnList = res.prodExKbnList;

          //輸送方式
          this.transMethodList = res.transMethodList;

          //担当者リストの取得
          this.connecterList = res.obUserCode;

          //クローズ状態リスト
          this.closeStateList = res.closeStateList;

          // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
          // 見積ターブルリスト
          this.quoteTypeList = res.quoteTypeList;
          // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

          // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
          // 目的港の追加
          this.destinationList = res.destinationPortList;
          // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑

          //初期値の設定
          this.setInitValue();
        })
        .catch((err) => {
          this.showFlag = false;

          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(
              t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
            );
          }

          //確定ボタンが使用不可に変更
          this.btnConfirmFlg = true;
        });
    },

    //入力内容のチェック
    inputCheck() {
      for (var i = 0; i < this.productInfoTable.length; i++) {
        const item = this.productInfoTable[i];

        //受注クローズ数,(注文数 - (入荷済み数(OK)-入荷クローズ数))の最小値
        let minCount = 0;

        //大連工場の場合
        if (this.isDaLianFac) {
          minCount = Math.min(
            item.odAcceptCloseQty,
            item.odProdQuantity - (item.odSizeCheckOkQty - item.odCrdCloseQty)
          );
        } else {
          minCount = Math.min(
            item.odAcceptCloseQty,
            item.odProdQuantity - (item.odReceOkQty - item.odJrdReceCloseQty)
          );
        }

        //クローズ数は上記最小値より大きい場合、メッセージを提示
        if (item.odProdCloseQty > minCount) {
          return false;
        }
      }

      return true;
    },

    //「確定」ボタン
    orderConfirm() {
      if (this.productInfoTable.length >= 1) {
        // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
        // ADD 2024/12/16 Wjx (#32827)受注データ取込の検討と対応 start↓

        // if (this.isEmptyOrNull(this.orderEditForm.obDueDate)) {
        //             Modal.showWarning("", t("message.ORDER.DUE_DATE_CHECK"), {
        //     confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        //             });
        //} else {
        // ADD 2024/12/16 Wjx (#32827)受注データ取込の検討と対応 end↑

        // 納期、注番の変更(見積単位⇒製品単位に変更)
        //仕入先納期が空のチェック
        for (var i = 0; i < this.productInfoTable.length; i++) {
          if (this.isEmptyOrNull(this.productInfoTable[i].odDueDate)) {
            Modal.showWarning("", t("message.ORDER.DUE_DATE_CHECK"), {
              confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
            });
            return;
          }

          // ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 start↓
          // 得意先納期　＜　仕入先納期　のチェックの追加
          if (
            new Date(this.productInfoTable[i].aodCusDeliveryDateShow) <=
            new Date(this.productInfoTable[i].odDueDate)
          ) {
            Modal.showWarning(
              "",
              "製品「" +
                this.productInfoTable[i].odProdName +
                " " +
                this.productInfoTable[i].odProdDrawNo +
                "」の" +
                t("message.ACCEPT_ORDER.DUE_DATE_COMPARE_CHECK"),
              {
                confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
              }
            );
            return;
          }
          // ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 end↑
        }
        // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
        // ADD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 start↓
        // 担当者が空の場合
        if (!this.userExitCheck()) {
          Modal.showWarning("", t("message.ORDER.USER_NOT_EXIST"), {
            confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
          });
          return;
        }
        // ADD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 end↑

        // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
        // 目的港の追加
        if (
          this.orderEditForm.obTransMethod == NUM_TWO &&
          this.isEmptyOrNull(this.orderEditForm.obDestinationCode)
        ) {
          Modal.showWarning("", t("message.ORDER.DESTINATION_PORT_CHECK"), {
            confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
          });
          return;
        }
        // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑

        if (this.localIsAdd) {
          //注文台帳新規作成
          this.addOrderDetailProc();
        } else {
          //注文台帳編集保存
          this.updateOrderDetailProc();
        }
        // }
      } else {
        Modal.showWarning("", t("message.ORDER.SEARCH_ACCEPT"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
      }

      // フォーカス削除
      this.$refs.confirmBtn.$el.blur();
    },

    //input-number表示
    showInputNumberCell(row, column) {
      // ADD 2026/10/10 Wjx フロント画面コントロールのロードの最適化 start↓
      // 編集列のみコントロールを表示する
      if (
        this.editingList.some((item) => item.value === column.prop) &&
        column.prop != this.editingColumn
      ) {
        return false;
      }
      // ADD 2026/10/10 Wjx フロント画面コントロールのロードの最適化 end↑

      // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
      //クローズの場合、行データが編集不可
      // if (
      //   (column.prop == "odProdCloseQty" ||
      //     this.editableColumns.includes(column.prop)) &&
      //   row.odCloseState == this.closeStateList[1]?.label
      // ) {
      //   return false;
      // }

      //正常製品の場合、クローズ数は入力可能
      // if (
      //   column.prop == "odProdCloseQty" &&
      //   row.odProdExKbnStr === NORMAL_PROD
      // ) {
      //   return true;
      // }

      //  if (
      //   this.editableColumns.includes(column.prop) &&
      //   (row.odSizeCheckOkQty || NUM_ZERO) == NUM_ZERO &&
      //   (row.odReceOkQty || NUM_ZERO) == NUM_ZERO
      // ) {
      //   return true;
      // }
      //  return false;

      if (
        this.editableColumns.includes(column.prop) &&
        (row.odSizeCheckOkQty || NUM_ZERO) == NUM_ZERO &&
        (row.odReceOkQty || NUM_ZERO) == NUM_ZERO
      ) {
        // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
        // 課題_納期分割機能の追加
        // if (row.id < 10000 && row.payFlg == STR_ZERO) {
        if (row.payFlg == STR_ZERO) {
          // 異常品・削減データ・分割・補足・削減データの場合、金額変更不可
          if (
            row.odProdExKbnStr !== NORMAL_PROD ||
            row.odReduceKbn !== "-" ||
            row.priceChangeFlg == STR_ONE ||
            // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
            // 一式機能の追加
            (this.ASetDataFlg && row.odProdUnit !== UNIT_SET)
            // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
          ) {
            return;
          }

          // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
          if (this.factoryKbn == FACTORY_KBN_DALIAN) {
            return "odUPriceCNY";
          } else {
            return "odUPrice";
          }
        }
        return "";
      }
      //検査室入荷OK数と日本入荷OK数が0の場合、加工単価は入力可能

      // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 課題_備考機能の追加
      // if (
      //   column.prop === "odProdRemarks" &&
      //   row.childrenCount > 1 &&
      //   row.id < 10000
      // ) {
      //   return "";
      // } else if (column.prop === "odProdRemarks") {
      //   return "odProdRemarks";
      // }
      // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
      return "";
      // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
    },

    //社内加工原価詳細画面
    showInternalProcessDialog() {
      //注文No.が空場合、社内加工原価詳細画面へ遷移不可
      if (this.orderEditForm.obOrderNoShow === STR_EMPTY) {
        Modal.showWarning("", t("message.ORDER.SEARCH_ACCEPT"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
        // フォーカス削除
        this.$refs.internalProcessBtn.$el.blur();
        return;
      }
      ShowInternalProcessCostDialog(
        {
          isAdd: this.localIsAdd,
          products: this.productInfoTable,
          orderEditForm: this.orderEditForm,
        },
        t("resource.ORDER.INTERNAL_PROCESS_COST_DIALOG"),
        (target) => {
          if (!!target) {
            //新規の場合
            if (this.localIsAdd) {
              //データ表示用
              this.productInfoTable = target;
            } else {
              //データ表示用の正常製品の削除
              let pitItems = this.productInfoTable.filter(
                (item) => item.odProdExKbnStr !== NORMAL_PROD
              );
              //更新後の正常製品の追加
              let pitUpdList = [...target, ...pitItems];
              pitUpdList.sort((a, b) => a.odOrderDetailNo - b.odOrderDetailNo);
              this.productInfoTable = pitUpdList;

              //最新の更新時刻の取得
              searchOrderDetailByOrderNo({ orderBasicInfo: this.orderEditForm })
                .then((res) => {
                  //更新時刻
                  this.orderEditForm.obUpdateTime =
                    res.Result.orderBasicInfo.obUpdateTime;
                })
                .catch((err) => {
                  if (err.data != null) {
                    Message.showError(
                      t(
                        "message.COMMON_MESSAGE." + err.data.Messages[0].Message
                      )
                    );
                  } else {
                    Message.showError(
                      t("message.COMMON_MESSAGE.SEARCH_FAILURE")
                    );
                  }
                });
            }
          }
        }
      );

      // フォーカス削除
      this.$refs.internalProcessBtn.$el.blur();
    },

    // 受注製品選択画面を表示
    showOrderProdDialog() {
      let selectItem = {};

      // if (this.orderEditForm.obSupCode == STR_EMPTY) {
      //   selectItem = { value: STR_EMPTY, label: STR_EMPTY, supAbb: STR_EMPTY };
      // } else {
      //   var selectSup = this.supplierCpyList.find(
      //     (item) => item.supCode === this.orderEditForm.obSupCode.split(":")[0]
      //   );

      //   selectItem = {
      //     value: selectSup?.supCode,
      //     label: selectSup?.supCode + ":" + selectSup?.supAbbreviation,
      //     supAbb: selectSup?.supAbb,
      //   };

      // }

      // var _obSupCode;
      // if (this.orderEditForm.obSupCode == STR_EMPTY) {
      //   _obSupCode = STR_EMPTY;
      // } else {
      //   _obSupCode = this.supplierCpyList.find(
      //     (item) => item.supCode === this.orderEditForm.obSupCode.split(":")[0]
      //   )?.supCode;
      // }

      // ADD 2026/10/10 Wjx フロント画面コントロールのロードの最適化 start↓
      this.editingColumn = STR_EMPTY;
      (this.editingList = [
        //仕入先納期
        {
          value: "odDueDate",
          label: t("resource.ORDER.OD_DUE_DATE"),
        },
        //加工単価(CNY)
        {
          value: "odUPriceCNY",
          label: t("resource.ORDER.PROCESS_UNIT_CNY"),
        },
        //加工単価(JPY)
        {
          value: "odUPrice",
          label: t("resource.ORDER.PROCESS_UNIT"),
        },
      ]),
        // ADD 2026/10/10 Wjx フロント画面コントロールのロードの最適化 end↑

        ShowOrderProdSelectDialog(
          {
            selectItem: this.supplierCpyAllList,
          },
          t("resource.ORDER.ORDER_PROD_SELECT"),
          (target) => {
            if (target) {
              //注文No.
              this.orderEditForm.obOrderNoShow =
                target.aobQuoteNo + CONNECTOR_SHORT_LINE + target.aobSupAbb;
              //見積No.
              this.orderEditForm.obQuoteNo = target.aobQuoteNo;

              this.supplierCpyList = JSON.parse(
                JSON.stringify(this.supplierCpyAllList)
              );

              this.orderEditForm.obSupCode = target.aobSupCode;

              //仕入先コードバックアップ
              this.orderEditForm.obSupCodeBak = JSON.parse(
                JSON.stringify(target.aobSupCode)
              );

              //ADD 2025/01/02 Wzc 課題_仕様変更の対応 Start↓
              this.factoryKbn = this.supplierCpyList.find(
                (item) => item.supCode === this.orderEditForm.obSupCode
              ).supFactoryKbn;
              //ADD 2025/01/02 Wzc 課題_仕様変更の対応 End↑

              // ADD 2026/10/10 Wjx フロント画面コントロールのロードの最適化 start↓
              // 編集列リスト内容の表示
              if (this.factoryKbn == FACTORY_KBN_DALIAN) {
                //大連工場の場合、加工単価（JPY）が非表示
                this.editingList = this.editingList.filter((item) => {
                  return item.value != "odUPrice";
                });
              } else {
                //大連工場以外の場合、加工単価（CNY）が非表示
                this.editingList = this.editingList.filter((item) => {
                  return item.value != "odUPriceCNY";
                });
              }
              // ADD 2026/10/10 Wjx フロント画面コントロールのロードの最適化 end↑

              //仕入先リストに同じ「工場」の保持
              var kbnVals =
                this.supplierCpyList.find(
                  (item) => item.supCode === this.orderEditForm.obSupCode
                ).supFactoryKbn == FACTORY_KBN_DALIAN
                  ? [FACTORY_KBN_DALIAN]
                  : [FACTORY_KBN_JAPAN, FACTORY_KBN_CPY];

              this.supplierCpyList = this.supplierCpyList.filter((item) =>
                kbnVals.includes(item.supFactoryKbn)
              );
              this.getAbleList();
              //プロセス区分
              this.orderEditForm.obProcKbn = target.aobProcKbn;

              //画面データの処理(検索用)
              const orderEditFormTmp = JSON.parse(
                JSON.stringify(this.orderEditForm)
              );
              orderEditFormTmp.obSupCode =
                orderEditFormTmp.obSupCode.split(":")?.[0];

              searchOrderProcSupCode(orderEditFormTmp)
                .then((res) => {
                  //一覧データ
                  this.productInfoTable = res;

                  // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
                  //見積ターブルを変更
                  if (
                    !!this.productInfoTable &&
                    this.productInfoTable[0].odQuoteType === STR_THREE
                  ) {
                    this.quoteType = STR_THREE;
                    this.quoteTypeVal = this.quoteTypeList.find(
                      (it) => it.value === this.quoteType
                    )?.label;
                  }
                  // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

                  // ADD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 start↓
                  this.allUrgentFlg = this.productInfoTable.every(
                    (item) => item.aodUrgentBool
                  );
                  // ADD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 end↑

                  // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
                  this.ASetDataFlg = this.productInfoTable.some(
                    (row) => row.odProdUnit === UNIT_SET
                  );
                  // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑

                  //データ表示の処理
                  this.dataProcess();

                  //新規、製品データがある場合、確定ボタンが使用可能
                  if (this.localIsAdd) {
                    this.btnConfirmFlg = false;
                  }
                })
                .catch((err) => {
                  if (err.data != null) {
                    Message.showError(
                      t(
                        "message.COMMON_MESSAGE." + err.data.Messages[0].Message
                      )
                    );
                  } else {
                    Message.showError(
                      t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
                    );
                  }
                })
                .finally(() => {
                  // setColumnWidth(this.columns, this.productInfoTable);
                });
            }
          }
        );

      // フォーカス削除
      this.$refs.ordSelectBtn.$el.blur();
    },

    // ADD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 start↓
    // ユーザが空のチェック
    userExitCheck() {
      if (this.isEmptyOrNull(this.orderEditForm.obUserCode)) {
        return false;
      }
      return true;
    },
    // ADD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 end↑

    //注文書出力
    outPutClick() {
      // ADD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 start↓
      // 担当者が空の場合
      if (!this.userExitCheck()) {
        Modal.showWarning("", t("message.ORDER.USER_NOT_EXIST"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
        return;
      }
      // ADD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 end↑
      // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
      // ShowOrderExcelOutputDialog(
      //   {
      //     isAdd: false,
      //     obOrderNo: this.orderEditForm.obOrderNo,
      //     obOrderNoShow: this.orderEditForm.obOrderNoShow,
      //     SupCurrency: this.supCurrency,
      //     FactoryKbn: this.factoryKbn,
      //   },
      //   t("resource.ORDER.ORDER_EXCEL_OUTPUT_DIALOG"),

      //   (target) => {
      //     //検索処理を行う
      //     this.getOrderDetailByOrderNo();
      //   }
      // );

      //保存前、データ処理
      this.dataAddUpdProc();

      var tmpTableData = this.orderDetailInfo.map((item) => {
        return {
          ...item,

          //クローズ状態の変換
          odCloseState: this.closeStateList.find(
            (it) => it.label === item.odCloseState
          )?.value,
        };
      });

      //更新処理
      updateOrderDetail({
        orderBasicInfo: this.orderEditForm,
        orderDetailInfoList: tmpTableData,
        loginUser: getUserInfo().UserId,
      })
        .then((res) => {
          Message.showSuccess(t("message.COMMON_MESSAGE.UPDATE_SUCCESS"));

          this.numLoads = 1;
          //手配日選択画面を表示
          this.showDateSelectDialog();
        })
        .catch((err) => {
          this.showFlag = false;

          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.UPDATE_FAILURE"));
          }
        });
      // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

      // フォーカス削除
      this.$refs.outPutBtn.$el.blur();
    },

    // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
    //手配日選択画面を表示
    showDateSelectDialog() {
      let odDateList = [];
      this.productInfoTable.reduce((acc, item) => {
        // DEL 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
        // 課題_納期分割機能の追加
        // if (item.childrenCount > 1) {
        //   // 子項の取得
        //   item.children.forEach((child) => {
        //     // 重複しないの手配日リストを取得
        //     // UPD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 start↓
        //     // 課題_検査室入荷日の追加
        //     // if (!odDateList.some((od) => od.odDate === child.odDate)) {
        //     if (
        //       child.odDate &&
        //       child.odDate != null &&
        //       !odDateList.some((od) => od.odDate === child.odDate)
        //     ) {
        //       // UPD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 end↑
        //       odDateList.push({ odDate: child.odDate });
        //     }
        //   });
        // } else {
        // DEL 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
        // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
        // 削減データの場合、手配日を追加しない
        // if (!odDateList.some((od) => od.odDate === item.odDate)) {
        if (
          item.odReduceKbn == "-" &&
          item.odProdQuantity !== NUM_ZERO &&
          item.odProdExKbn == NUM_ZERO &&
          !odDateList.some((od) => od.odDate === item.odDate)
        ) {
          // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
          odDateList.push({ odDate: item.odDate });
        }
        // }
      }, []);

      // UPD 2025/03/19 ZLL 課題_形状、素材、処理を削除したい start↓
      // 昇順ソート順
      // odDateList.sort((a, b) => new Date(a) - new Date(b));
      // 降順ソート順
      odDateList.sort((a, b) => new Date(b.odDate) - new Date(a.odDate));
      // UPD 2025/03/19 ZLL 課題_形状、素材、処理を削除したい end↑

      ShowOrderDateSelectDialog(
        {
          odDateList: odDateList,
          obOrderNo: this.orderEditForm.obOrderNo,
          obOrderNoShow: this.orderEditForm.obOrderNoShow,
          SupCurrency: this.supCurrency,
          FactoryKbn: this.factoryKbn,
        },
        t("resource.ORDER.ORDER_DATE_SELECT_DIALOG"),

        // UPD 2025/03/19 ZLL 課題_出力後、状態の自動変更の追加 start↓
        // (target) => {
        //   //検索処理を行う
        //   this.getOrderDetailByOrderNo();
        // }
        this.getOrderDetailByOrderNo
        // UPD 2025/03/19 ZLL 課題_出力後、状態の自動変更の追加 end↑
      );
    },
    // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

    // 製品異常（赤い文字）
    rowClassName({ row }) {
      // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
      // if (
      //   row.odProdExKbnStr != NORMAL_PROD &&
      //   row.odProdExKbn != this.prodExKbnList[0].value
      // ) {
      //   return "textColor";
      // }

      if (
        (!row.odProdQuantity ||
          row.odProdQuantity == null ||
          row.odProdQuantity == 0) &&
        row.childrenCount > 1
      ) {
        return;
      }

      if (
        (!row.odProdQuantity ||
          row.odProdQuantity == null ||
          row.odProdQuantity == 0) &&
        row.id > 10000 &&
        // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 start↓
        // 課題_検査室入荷日の追加
        // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
        // row.dataKbn !== STR_TWO
        row.dataKbn !== STR_TWO &&
        row.dataKbn !== STR_THREE
        // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑
        // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 end↑
      ) {
        return "hidden-row";
      }
      // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

      // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
      // 課題_納期分割機能の追加
      if (
        (row.odProdExKbnStr != NORMAL_PROD && row.id < 10000) ||
        (row.id > 10000 &&
          (row.odProdExKbn != STR_ZERO || row.odProdReceExKbn != STR_ZERO))
      ) {
        return "textColor";
      }

      // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
    },

    //初期値の設定
    setInitValue() {
      //新規作成の場合
      if (this.localIsAdd) {
        this.activeNames = ["orderBasic"];
        this.handleCollapseChange(this.activeNames);

        //注文日:システム日
        this.orderEditForm.obDate = new Date();
        //注文状態：新規
        this.orderEditForm.obStatus = this.orderStatusList[0].value;
        //支払状態
        this.orderEditForm.obPayStatus = this.paymentStatusList[0].value;
        // 担当者
        this.orderEditForm.obUserCode = getUserInfo().UserId;
        this.getAbleList();
        // 仕入先
        //this.orderEditForm.obSupCode = this.supplierCpyList[0].supCode;

        //輸送方式
        this.orderEditForm.obTransMethod = this.transMethodList[0].value;

        //確定ボタン使用不可
        this.btnConfirmFlg = true;

        this.showFlag = false;
      } else {
        this.activeNames = [""];
        this.handleCollapseChange(this.activeNames);

        //編集場合、受注製品選択ボタンが使用不可
        this.btnOrdSelectFlag = true;

        //注文書出力ボタンが使用可能に変更
        this.buttonClickFlag = false;

        //注文No.表示用
        this.orderEditForm.obOrderNoShow = this.rowData.obOrderNoShow;
        //注文No.データ取得/更新/編集用
        this.orderEditForm.obOrderNo = this.rowData.obOrderNo;

        //仕入先
        this.orderEditForm.obSupCode = this.rowData.obSupCode;
        //仕入先コードバックアップ
        this.orderEditForm.obSupCodeBak = JSON.parse(
          JSON.stringify(this.rowData.obSupCode)
        );

        // ADD 2026/10/10 Wjx フロント画面コントロールのロードの最適化 start↓
        //工場区分の取得
        this.factoryKbn = STR_EMPTY;
        if (!!this.orderEditForm.obSupCode) {
          this.factoryKbn = this.supplierCpyList.find(
            (item) =>
              item.supCode === this.orderEditForm.obSupCode.split(":")[0]
          ).supFactoryKbn;
        }

        // 編集列リスト内容の表示
        if (this.factoryKbn == FACTORY_KBN_DALIAN) {
          //大連工場の場合、加工単価（JPY）が非表示
          this.editingList = this.editingList.filter((item) => {
            return item.value != "odUPrice";
          });
        } else {
          //大連工場以外の場合、加工単価（CNY）が非表示
          this.editingList = this.editingList.filter((item) => {
            return item.value != "odUPriceCNY";
          });
        }
        // ADD 2026/10/10 Wjx フロント画面コントロールのロードの最適化 end↑

        //注文No.による注文詳細情報の取得
        this.getOrderDetailByOrderNo();
      }
    },

    //使用可能な担当者リスト、仕入先リストの取得
    getAbleList() {
      // 担当者リスト
      this.connecterList = getAbleUserInfoList(
        this.connecterList,
        this.orderEditForm.obUserCode
      );

      var supCode;
      if (!!this.orderEditForm.obSupCode) {
        supCode = this.orderEditForm.obSupCode.split(":")[0];
      }
      // 仕入先リスト
      this.supplierCpyList = getAbleSupplierInfoList(
        this.supplierCpyList,
        supCode
      );

      if (!this.orderEditForm.obSupCode) {
        //仕入先コード
        this.orderEditForm.obSupCode = this.supplierCpyList[0]?.supCode;
        //仕入先コードバックアップ
        this.orderEditForm.obSupCodeBak = JSON.parse(
          JSON.stringify(this.supplierCpyList[0]?.supCode)
        );
      }

      // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
      // 目的港の追加
      this.destinationList = getAbleDestinationList(
        this.destinationList,
        this.orderEditForm.obDestinationCode
      );
      // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑
    },

    //セルの配置
    tableCellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column.index = columnIndex;

      // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
      // 課題_納期分割機能の追加
      //クローズの場合、行データが編集不可
      // if (
      //   (column.property == "odProdCloseQty" ||
      //     this.editableColumns.includes(column.property)) &&
      //   row.odCloseState == this.closeStateList[1]?.label
      // ) {
      //   return;
      // }
      // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑

      // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
      // 品質保証部の権限を追加する
      if (this.isDLUserLocal) {
        // 課題_検査室入荷日の追加
        var chkRcvColumnColorFlg =
          row.id >= 10000 &&
          row.dataKbn === STR_THREE &&
          ((column.property == "odProdName" && !row.odProdName) ||
            (column.property == "odProdDrawNo" && !row.odProdDrawNo) ||
            (column.property == "odProdUnit" && !row.odProdUnit) ||
            // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
            (column.property == "aodMisumiKbnStr" && !row.aodMisumiKbnStr) || // ミスミ関連区分
            // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑
            (column.property == "odDueDate" && !row.odDueDate) ||
            (column.property == "odDueDateHistory" && !row.odDueDateHistory) ||
            (column.property == "aodCusDeliveryDateShow" &&
              !row.aodCusDeliveryDateShow) ||
            (column.property == "aodCusDeliveryDateHistory" &&
              !row.aodCusDeliveryDateHistory) ||
            (column.property == "aodDiscussStatus" && !row.aodDiscussStatus) ||
            (column.property == "odProdQuantity" && !row.odProdQuantity) ||
            (column.property == "odProdShape" && !row.odProdShape) ||
            (column.property == "odProdMaterial" && !row.odProdMaterial) ||
            (column.property == "odProdTreatment" && !row.odProdTreatment) ||
            (column.property == "odUPrice" && !row.odUPrice) ||
            (column.property == "odUPriceCNY" && !row.odUPriceCNY) ||
            (column.property == "odPayStatusStr" && !row.odPayStatusStr) ||
            (column.property == "odTotal" && !row.odTotal) ||
            (column.property == "odTotalCNY" && !row.odTotalCNY) ||
            (column.property == "odDate" && !row.odDate) ||
            (column.property == "odReceOkQty" && !row.odReceOkQty) ||
            // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
            // 課題_納期分割機能の追加
            column.property == "odProdExKbnStr" ||
            (column.property == "odReduceKbn" && !row.odReduceKbn) ||
            (column.property == "odCloseStateBool" && !row.odCloseStateBool) |
              // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
              // // 手配の場合、緊急度が編集可能の変更
              // (column.property == "aodUrgent" && !row.aodUrgent) ||
              (column.property == "aodUrgentBool" && !row.aodUrgentBool) ||
            // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
            // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
            // 目的港の追加
            (column.property == "odDpName" && !row.odDpName) ||
            // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑
            // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
            (column.property == "odTransQty" && !row.odTransQty) ||
            (column.property == "aodProdRemarksSum" && !row.aodProdRemarksSum));

        var chkRcvChildCount = 0;
        if (row.children) {
          chkRcvChildCount = row.children.filter(
            // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
            // (item) => item.id >= 10000 && item.dataKbn === STR_TWO
            (item) => item.id >= 10000 && item.dataKbn === STR_THREE
            // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑
          ).length;
        }
        //検査室入荷日別の場合
        if (
          chkRcvColumnColorFlg ||
          (row.id < 10000 &&
            column.property == "odCheckRcvDateStr" &&
            this.isEmptyOrNull(row.odCheckRcvDateStr))
          // && chkRcvChildCount > 1
        ) {
          return "bg-cell-editable_grey";
        }

        // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
        var msmDlColumnColorFlg =
          row.id >= 10000 &&
          row.dataKbn === STR_TWO &&
          ((column.property == "odProdUnit" && !row.odProdUnit) ||
            (column.property == "odDueDate" && !row.odDueDate) ||
            (column.property == "odDueDateHistory" && !row.odDueDateHistory) ||
            (column.property == "aodCusDeliveryDateShow" &&
              !row.aodCusDeliveryDateShow) ||
            (column.property == "aodCusDeliveryDateHistory" &&
              !row.aodCusDeliveryDateHistory) ||
            (column.property == "aodDiscussStatus" && !row.aodDiscussStatus) ||
            (column.property == "odProdQuantity" && !row.odProdQuantity) ||
            (column.property == "odProdShape" && !row.odProdShape) ||
            (column.property == "odProdMaterial" && !row.odProdMaterial) ||
            (column.property == "odProdTreatment" && !row.odProdTreatment) ||
            (column.property == "odUPrice" && !row.odUPrice) ||
            (column.property == "odUPriceCNY" && !row.odUPriceCNY) ||
            (column.property == "odPayStatusStr" && !row.odPayStatusStr) ||
            (column.property == "odTotal" && !row.odTotal) ||
            (column.property == "odTotalCNY" && !row.odTotalCNY) ||
            (column.property == "odDate" && !row.odDate) ||
            (column.property == "odReceOkQty" && !row.odReceOkQty) ||
            column.property == "odProdExKbnStr" ||
            (column.property == "odReduceKbn" && !row.odReduceKbn) ||
            (column.property == "odCloseStateBool" && !row.odCloseStateBool) ||
            // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
            // (column.property == "aodUrgent" && !row.aodUrgent) ||
            (column.property == "aodUrgentBool" && !row.aodUrgentBool) ||
            // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
            // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
            // 目的港の追加
            (column.property == "odDpName" && !row.odDpName) ||
            // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑
            (column.property == "odCheckRcvDateStr" &&
              !row.odCheckRcvDateStr) ||
            (column.property == "odSizeCheckOkQty" && !row.odSizeCheckOkQty) ||
            (column.property == "odTransQty" && !row.odTransQty) ||
            (column.property == "aodProdRemarksSum" && !row.aodProdRemarksSum));

        //ミスミ_大連子データの場合
        if (msmDlColumnColorFlg) {
          return "bg-cell-editable_grey";
        }
        // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑
        return;
      }
      // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑

      // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
      //検査室入荷数と日本入荷が0の場合、加工単価は変更可能な背景色に設定する
      // if (
      //   this.editableColumns.includes(column.property) &&
      //   (row.odSizeCheckOkQty || NUM_ZERO) == NUM_ZERO &&
      //   (row.odReceOkQty || NUM_ZERO) == NUM_ZERO
      // ) {
      //   //編集可能の背景色
      //   return "bg-cell-editable";
      // }

      // //編集と正常製品の場合、クローズ数は変更可能な背景色に設定する
      // if (
      //   "odProdCloseQty" == column.property &&
      //   !this.localIsAdd &&
      //   row.odProdExKbnStr === NORMAL_PROD
      // ) {
      //   //編集可能の背景色
      //   return "bg-cell-editable";
      // }

      // 手配数＜０の場合、文字は赤を表示
      if (
        (column.property === "odProdQuantity" && row.odProdQuantity < 0) ||
        (column.property === "odTotal" &&
          formatCurrencyToNumber(row.odTotal) < 0) ||
        (column.property === "odTotalCNY" &&
          formatCurrencyToNumber(row.odTotalCNY) < 0)
      ) {
        return "txt-cell-editable_red";
      }
      // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
      // 課題_納期分割機能の追加
      // 異常品が入荷の場合、クローズボックスをクリック可能
      if (row.odProdExKbn === STR_TWO && row.odProdReceExKbn == STR_ZERO) {
        if (
          column.property == "odCloseStateBool" &&
          (row.odSizeCheckOkQty || NUM_ZERO) == NUM_ZERO &&
          (row.odReceOkQty || NUM_ZERO) == NUM_ZERO &&
          row.id < 10000
        ) {
          //編集可能の背景色
          return "bg-cell-editable";
        }
      }

      if (
        (row.odReduceKbn !== "-" || row.odCloseStateBool) &&
        row.id < 10000 &&
        !this.localIsAdd
      ) {
        if (
          column.property == "odDueDate" ||
          column.property == "odUPriceCNY" ||
          column.property == "odUPrice" ||
          // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
          column.property == "aodUrgentBool"
          // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
        ) {
          return;
        }
      }
      // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
      else if (
        this.localIsAdd &&
        row.id < 10000 &&
        (row.odReduceKbn !== "-" || row.odCloseStateBool)
      ) {
        if (
          column.property == "odUPriceCNY" ||
          column.property == "odUPrice" ||
          // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
          column.property == "aodUrgentBool"
          // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
        ) {
          return;
        }
      }
      // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
      // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑

      //検査室入荷数と日本入荷が0の場合、加工単価は変更可能な背景色に設定する
      if (
        this.editableColumns.includes(column.property) &&
        (row.odSizeCheckOkQty || NUM_ZERO) == NUM_ZERO &&
        (row.odReceOkQty || NUM_ZERO) == NUM_ZERO
      ) {
        // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
        // 課題_納期分割機能の追加
        // if (row.id < 10000 && row.payFlg == STR_ZERO) {
        //正常品の場合、加工単価は変更可能、異常品の場合、加工単価は変更不可
        if (
          row.id < 10000 &&
          row.payFlg == STR_ZERO &&
          row.odProdExKbnStr === NORMAL_PROD
        ) {
          if (
            // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
            // 一式機能の追加
            // row.priceChangeFlg == STR_ONE
            (row.priceChangeFlg == STR_ONE ||
              (this.ASetDataFlg && row.odProdUnit !== UNIT_SET)) &&
            // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑

            (column.property == "odUPriceCNY" || column.property == "odUPrice")
          ) {
            return;
          }
          // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
          //編集可能の背景色
          return "bg-cell-editable";
        }
        // return "bg-cell-editable_grey";
      }
      // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 課題_備考機能の追加
      // if (column.property === "odProdRemarks") {
      //   if (row.childrenCount > 1 && row.id < 10000) {
      //     return "bg-cell-editable_grey";
      //   } else {
      //     //編集可能の背景色
      //     return "bg-cell-editable";
      //   }
      // }
      if (column.property === "aodProdRemarksSum") {
        if (row.id > 10000) {
          return "bg-cell-editable_grey";
        }
      }
      // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
      // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 納期、注番の変更(見積単位⇒製品単位に変更)
      if (column.property === "odDueDate") {
        if (row.id >= 10000) {
          return "bg-cell-editable_grey";
        } else {
          //編集可能の背景色
          return "bg-cell-editable";
        }
      }
      // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

      // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
      // 手配の場合、緊急度が編集可能の変更
      if (column.property === "aodUrgentBool") {
        if (row.id >= 10000) {
          return "bg-cell-editable_grey";
        } else {
          //編集可能の背景色
          return "bg-cell-editable";
        }
      }
      // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑

      // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 start↓
      // 課題_検査室入荷日の追加
      var chkRcvColumnColorFlg =
        row.id >= 10000 &&
        // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
        // row.dataKbn === STR_TWO &&
        row.dataKbn === STR_THREE &&
        // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑
        ((column.property == "odProdName" && !row.odProdName) ||
          (column.property == "odProdDrawNo" && !row.odProdDrawNo) ||
          (column.property == "odProdUnit" && !row.odProdUnit) ||
          // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
          (column.property == "aodMisumiKbnStr" && !row.aodMisumiKbnStr) || // ミスミ関連区分
          // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑
          (column.property == "odDueDate" && !row.odDueDate) ||
          (column.property == "odDueDateHistory" && !row.odDueDateHistory) ||
          (column.property == "aodCusDeliveryDateShow" &&
            !row.aodCusDeliveryDateShow) ||
          (column.property == "aodCusDeliveryDateHistory" &&
            !row.aodCusDeliveryDateHistory) ||
          (column.property == "aodDiscussStatus" && !row.aodDiscussStatus) ||
          (column.property == "odProdQuantity" && !row.odProdQuantity) ||
          (column.property == "odProdShape" && !row.odProdShape) ||
          (column.property == "odProdMaterial" && !row.odProdMaterial) ||
          (column.property == "odProdTreatment" && !row.odProdTreatment) ||
          (column.property == "odUPrice" && !row.odUPrice) ||
          (column.property == "odUPriceCNY" && !row.odUPriceCNY) ||
          (column.property == "odPayStatusStr" && !row.odPayStatusStr) ||
          (column.property == "odTotal" && !row.odTotal) ||
          (column.property == "odTotalCNY" && !row.odTotalCNY) ||
          (column.property == "odDate" && !row.odDate) ||
          (column.property == "odReceOkQty" && !row.odReceOkQty) ||
          // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
          // 課題_納期分割機能の追加
          column.property == "odProdExKbnStr" ||
          (column.property == "odReduceKbn" && !row.odReduceKbn) ||
          (column.property == "odCloseStateBool" && !row.odCloseStateBool) ||
          // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
          // (column.property == "aodUrgent" && !row.aodUrgent) ||
          (column.property == "aodUrgentBool" && !row.aodUrgentBool) ||
          // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑

          // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
          // 目的港の追加
          (column.property == "odDpName" && !row.odDpName) ||
          // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑

          // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
          (column.property == "odTransQty" && !row.odTransQty) ||
          (column.property == "aodProdRemarksSum" && !row.aodProdRemarksSum));

      var chkRcvChildCount = 0;
      if (row.children) {
        chkRcvChildCount = row.children.filter(
          // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
          // (item) => item.id >= 10000 && item.dataKbn === STR_TWO
          (item) => item.id >= 10000 && item.dataKbn === STR_THREE
          // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑
        ).length;
      }
      //検査室入荷日別の場合
      if (
        chkRcvColumnColorFlg ||
        (row.id < 10000 &&
          column.property == "odCheckRcvDateStr" &&
          this.isEmptyOrNull(row.odCheckRcvDateStr))
        // && chkRcvChildCount > 1
      ) {
        return "bg-cell-editable_grey";
      }
      // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
      var msmDlColumnColorFlg =
        row.id >= 10000 &&
        row.dataKbn === STR_TWO &&
        ((column.property == "odProdUnit" && !row.odProdUnit) ||
          (column.property == "odDueDate" && !row.odDueDate) ||
          (column.property == "odDueDateHistory" && !row.odDueDateHistory) ||
          (column.property == "aodCusDeliveryDateShow" &&
            !row.aodCusDeliveryDateShow) ||
          (column.property == "aodCusDeliveryDateHistory" &&
            !row.aodCusDeliveryDateHistory) ||
          (column.property == "aodDiscussStatus" && !row.aodDiscussStatus) ||
          (column.property == "odProdQuantity" && !row.odProdQuantity) ||
          (column.property == "odProdShape" && !row.odProdShape) ||
          (column.property == "odProdMaterial" && !row.odProdMaterial) ||
          (column.property == "odProdTreatment" && !row.odProdTreatment) ||
          (column.property == "odUPrice" && !row.odUPrice) ||
          (column.property == "odUPriceCNY" && !row.odUPriceCNY) ||
          (column.property == "odPayStatusStr" && !row.odPayStatusStr) ||
          (column.property == "odTotal" && !row.odTotal) ||
          (column.property == "odTotalCNY" && !row.odTotalCNY) ||
          (column.property == "odDate" && !row.odDate) ||
          (column.property == "odReceOkQty" && !row.odReceOkQty) ||
          column.property == "odProdExKbnStr" ||
          (column.property == "odReduceKbn" && !row.odReduceKbn) ||
          (column.property == "odCloseStateBool" && !row.odCloseStateBool) ||
          // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
          // (column.property == "aodUrgent" && !row.aodUrgent) ||
          (column.property == "aodUrgentBool" && !row.aodUrgentBool) ||
          // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑

          // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
          // 目的港の追加
          (column.property == "odDpName" && !row.odDpName) ||
          // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑
          (column.property == "odCheckRcvDateStr" && !row.odCheckRcvDateStr) ||
          (column.property == "odSizeCheckOkQty" && !row.odSizeCheckOkQty) ||
          (column.property == "odTransQty" && !row.odTransQty) ||
          (column.property == "aodProdRemarksSum" && !row.aodProdRemarksSum));

      //ミスミ_大連子データの場合
      if (msmDlColumnColorFlg) {
        return "bg-cell-editable_grey";
      }
      // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑

      // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 end↑

      var columnColorFlg =
        row.id >= 10000 &&
        // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 start↓
        // 課題_検査室入荷日の追加
        row.dataKbn == STR_ONE &&
        // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 end↑
        ((column.property == "odProdName" && !row.odProdName) ||
          (column.property == "odProdDrawNo" && !row.odProdDrawNo) ||
          (column.property == "odProdUnit" && !row.odProdUnit) ||
          // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 納期、注番の変更(見積単位⇒製品単位に変更)
          (column.property == "odDueDate" && !row.odDueDate) ||
          (column.property == "odDueDateHistory" && !row.odDueDateHistory) ||
          // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

          // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 start↓
          // 課題_打合状態、納期の追加
          (column.property == "aodCusDeliveryDateShow" &&
            !row.aodCusDeliveryDateShow) ||
          (column.property == "aodCusDeliveryDateHistory" &&
            !row.aodCusDeliveryDateHistory) ||
          (column.property == "aodDiscussStatus" && !row.aodDiscussStatus) ||
          // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 end↑

          (column.property == "odProdShape" && !row.odProdShape) ||
          (column.property == "odProdMaterial" && !row.odProdMaterial) ||
          (column.property == "odProdTreatment" && !row.odProdTreatment) ||
          (column.property == "odUPrice" && !row.odUPrice) ||
          (column.property == "odUPriceCNY" && !row.odUPriceCNY) ||
          (column.property == "odPayStatusStr" && !row.odPayStatusStr) ||
          (column.property == "odTotal" && !row.odTotal) ||
          (column.property == "odTotalCNY" && !row.odTotalCNY) ||
          (column.property == "odReceOkQty" && !row.odReceOkQty) ||
          (column.property == "odTransQty" && !row.odTransQty) ||
          // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 課題_備考機能の追加
          // (column.property == "odProdRemarks" && !row.odProdRemarks) ||
          (column.property == "aodProdRemarksSum" && !row.aodProdRemarksSum) ||
          // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 start↓
          // 課題_検査室入荷日の追加
          (column.property == "odCheckRcvDateStr" && !row.odCheckRcvDateStr) ||
          // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 end↑
          (column.property == "odSizeCheckOkQty" && !row.odSizeCheckOkQty));

      if (
        columnColorFlg ||
        (row.id < 10000 &&
          column.property == "odDate" &&
          !row.odDate &&
          row.childrenCount > 1)
      ) {
        return "bg-cell-editable_grey";
      }

      // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
    },

    //再入荷ボタン
    restockBtnProc() {
      // フォーカス削除
      this.$refs.restockBtn.$el.blur();
      ShowRestockDialog(
        {
          isAdd: false,
          obOrderNoShow: this.orderEditForm.obOrderNoShow,
          obOrderNo: this.orderEditForm.obOrderNo,
          SupCurrency: this.supCurrency,
          FactoryKbn: this.factoryKbn,
        },
        t("resource.ORDER.RESTOCK"),
        (target) => {
          this.getOrderDetailByOrderNo();
        }
      );
    },

    //製品クローズ選択ボタン
    productCloseSelectBtnProc() {
      // フォーカス削除
      this.$refs.productCloseSelectBtn.$el.blur();
      //
      ShowProductCloseSelectInOrderDialog(
        {
          obOrderNoShow: this.orderEditForm.obOrderNoShow,
          obOrderNo: this.orderEditForm.obOrderNo,
        },
        t("resource.ORDER.PRODUCT_CLOSE_SELECT"),
        (target) => {
          this.getOrderDetailByOrderNo();
        }
      );
    },

    //フォームで変更される可能性のアイテムの取得
    extractBasic(data) {
      // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
      // UPD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
      // 目的港の追加
      // if (data.facKbn == FACTORY_KBN_DALIAN) {
      var facKbn = this.supplierCpyList.find(
        (it) => it.supCode === data.obSupCode
      )?.supFactoryKbn;
      if (facKbn == FACTORY_KBN_DALIAN) {
        // UPD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑
        // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
        return {
          obSupCode: data.obSupCode,
          obDate: data.obDate,
          // DEL 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 納期、注番の変更(見積単位⇒製品単位に変更)
          //obDueDate: data.obDueDate,
          // DEL 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

          obStatus: data.obStatus,
          obPayStatus: data.obPayStatus,
          obUserCode: data.obUserCode,
          obTransMethod: data.obTransMethod,
          // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
          // 目的港の追加
          obDestinationCode: data.obDestinationCode,
          // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑
        };
        // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
      } else {
        return {
          obSupCode: data.obSupCode,
          obDate: data.obDate,
          // DEL 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 納期、注番の変更(見積単位⇒製品単位に変更)
          //obDueDate: data.obDueDate,
          // DEL 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

          obStatus: data.obStatus,
          obPayStatus: data.obPayStatus,
          obUserCode: data.obUserCode,
        };
      }
      // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
    },
    //テーブルで変更される可能性のある列の取得
    extractDetail(data) {
      return data.map((item, index) => {
        return {
          index: index,
          odUPrice: item.odUPrice,
          //ADD 2025/01/02 Wzc 課題_仕様変更の対応 Start↓
          // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
          // odUPriceCNY: parseInt(item.odUPriceCNY),
          odUPriceCNY: item.odUPriceCNY,
          // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑
          //ADD 2025/01/02 Wzc 課題_仕様変更の対応 End↑
          // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 納期、注番の変更(見積単位⇒製品単位に変更)
          odDueDate: item.odDueDate,
          // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

          // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
          // 課題_納期分割機能の追加
          odCloseStateBool: item.odCloseStateBool,
          // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑

          // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
          // 手配の場合、緊急度が編集可能の変更
          aodUrgentBool: item.aodUrgentBool, // 緊急度
          // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
        };
      });
    },

    //ダイアログを閉じる
    onCancel() {
      var tmpTableData = JSON.parse(JSON.stringify(this.orderEditForm));
      tmpTableData.obDate = formatDateToString(tmpTableData.obDate);
      // DEL 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 納期、注番の変更(見積単位⇒製品単位に変更)
      // tmpTableData.obDueDate =
      //   tmpTableData.obDueDate == null
      //     ? ""
      //     : formatDateToString(tmpTableData.obDueDate);
      // DEL 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

      if (
        (!this.localIsAdd &&
          (!cmpBasicData(
            this.cmpBasicResult,
            this.extractBasic(tmpTableData)
          ) ||
            !cmpDetailData(
              // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
              // 納期、注番の変更(見積単位⇒製品単位に変更)
              //this.cmpDetailResult,
              //this.extractDetail(this.productInfoTable)
              JSON.parse(JSON.stringify(this.cmpDetailResult)),
              JSON.parse(
                JSON.stringify(this.extractDetail(this.productInfoTable))
              )
              // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
            ))) ||
        (this.localIsAdd && this.productInfoTable.length > 0)
      ) {
        return new Promise((resolve, reject) => {
          Modal.showWarning(
            "",
            t("message.COMMON_MESSAGE.DATA_ALREADY_CHANGED_CLOSE"),
            {
              $type: "prompt",
              confirmButtonText: t("resource.button.sure"),
              cancelButtonText: t("resource.button.cancel"),
              showCancelButton: true,
            }
          )
            .then(() => {
              // 用户点击确认
              resolve(true);
            })
            .catch((error) => {
              // 用户点击取消或关闭对话框
              resolve(false);
            });
        });
      } else {
        return true;
      }
    },

    // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
    // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
    // 課題_備考機能の追加
    //備考入力のチェック
    // remarksInputProc(row, column) {
    //   //備考以外の場合、何もしない
    //   if (column.prop !== "odProdRemarks") {
    //     return;
    //   }

    //   if (
    //     column.prop === "odProdRemarks" &&
    //     row.childrenCount > 1 &&
    //     row.id < 10000
    //   ) {
    //     return false;
    //   }
    //   return true;
    // },
    // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

    // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
    // 納期、注番の変更(見積単位⇒製品単位に変更)

    //納期コントロール
    dueDateInputProc(row, column) {
      // ADD 2026/10/10 Wjx フロント画面コントロールのロードの最適化 start↓
      // 編集列のみコントロールを表示する
      if (
        this.editingList.some((item) => item.value === column.prop) &&
        column.prop != this.editingColumn
      ) {
        return false;
      }
      // ADD 2026/10/10 Wjx フロント画面コントロールのロードの最適化 end↑
      //納期以外の場合、何もしない
      if (column.prop !== "odDueDate") {
        return;
      }
      if (row.id >= 10000) {
        return false;
      }
      return true;
    },
    // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

    // 入力ボックスをクリックの場合、値をすべて選択します
    selectValue(e) {
      e.target.select();
    },

    //Enter処理
    remarksFocusNextInput(index, columnProp) {
      index = index + 1;
      let dataSize = this.productInfoTable.length;

      for (let num = 0; num < this.productInfoTable.length; num++) {
        const element = this.productInfoTable[num];
        dataSize += element.childrenCount;
      }

      if (index > dataSize - 1) {
        for (var i = 0; i < dataSize; i++) {
          if (this.$refs[`input${i}-${columnProp}`] !== undefined) {
            this.$refs[`input${i}-${columnProp}`][0].focus();
            break;
          }
        }
      } else {
        var i = index;
        for (i; i < dataSize; i++) {
          if (this.$refs[`input${i}-${columnProp}`] !== undefined) {
            this.$refs[`input${i}-${columnProp}`][0].focus();
            break;
          }
        }
        //下に入力ボックスがない場合は、最初から
        if (i == dataSize) {
          this.focusNextInput(-1, columnProp);
        }
      }
    },
    // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
    // ADD 2024/12/16 Wjx (#32827)受注データ取込の検討と対応 start↓
    //値がNULLまたはEmptyです
    isEmptyOrNull(item) {
      if (item == undefined || item == STR_EMPTY) {
        return true;
      } else {
        return false;
      }
    },
    // ADD 2024/12/16 Wjx (#32827)受注データ取込の検討と対応 end↑

    // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
    // 課題_備考機能の追加
    addRemarksProd(row, event) {
      // フォーカス削除
      event.currentTarget.blur();
      let remarks = STR_EMPTY;
      if (!this.showFlag) {
        this.showFlag = true;
      }
      showRemarksUpdDialog(
        this,
        row.odQuoteNo,
        row.odProdNo,
        row.aodProdRemarksSum
      )
        .then((res) => {
          remarks = res;
        })
        .finally(() => {
          this.numLoads = 1;

          // 待ちダイアログを閉じる
          if (this.showFlag) {
            this.showFlag = false;
          }
          if (remarks != STR_EMPTY) {
            // 備考を更新する
            row.aodProdRemarksSum = remarks;
            this.$set(this.productInfoTable, row.index, row);
          }
        });
    },

    //備考表示用
    formatRemarksShowProc(value) {
      return formatRemarksShow(value);
    },

    getIconTypeProc(value) {
      return getIconType(value);
    },

    refreshTable() {
      this.tableKey += 1; // key値を更新し、テーブルの再レンダリングをトリガーする
    },
    // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

    // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
    // 共通備考の調整（備考列幅の設定）
    getRemarksColumnWidthProc() {
      return getRemarksColumnWidth(this.productInfoTable);
    },

    //共通備考の調整（備考の表示と保存）
    showRemarksDialogProc(row, event) {
      // フォーカス削除
      event.currentTarget.blur();
      if (!this.showFlag) {
        this.showFlag = true;
      }

      showRemarksDialog(
        this,
        row.odQuoteNo,
        row.odProdNo,
        row.aodProdRemarksSum,
        row.aodProdRemarksSum,
        this.aodUpdateTime
      )
        .then((res) => {
          if (!this.isEmptyOrNull(res)) {
            // 備考を更新する
            row.aodProdRemarksSum = res.aodProdRemarks;
            this.aodUpdateTime = res.aodUpdateTime;
            this.$set(this.productInfoTable, row.index, row);
          }
        })
        .finally(() => {
          this.numLoads = 1;

          // 待ちダイアログを閉じる
          if (this.showFlag) {
            this.showFlag = false;
          }
        });
    },
    // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑

    // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
    // 課題_納期分割機能の追加
    checkBoxDisableProc(row) {
      if (this.isDLUserLocal) {
        return true;
      }
      if (
        row.odProdExKbn !== STR_ZERO &&
        (row.odSizeCheckOkQty || NUM_ZERO) == NUM_ZERO &&
        (row.odReceOkQty || NUM_ZERO) == NUM_ZERO
      ) {
        return false;
      }
      return true;
    },
    // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑

    // UPD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 start↓
    allUrgentCheckboxChange(checked) {
      this.productInfoTable.forEach((item) => (item.aodUrgentBool = !!checked));
    },
    // UPD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 end↑
  },
};
</script>
<style scoped>
.el-table__body {
  height: 200px;
}
.editInput {
  width: 90%;
  height: 17px;
}
</style>
